<template>
  <div class="coracao-producao">
    <!-- Loading State -->
    <div v-if="carregando" class="d-flex justify-center align-center pa-8">
      <v-progress-circular indeterminate color="primary" size="64" />
      <span class="ml-4 text-h6">Carregando dados da produção...</span>
    </div>



    <!-- Error State -->
    <v-alert v-if="erro" type="error" density="compact" class="mb-4">
      {{ erro }}
      <div class="mt-2">
        <v-btn variant="text" size="small" color="white" @click="carregarDados()" prepend-icon="mdi-refresh">
          Tentar novamente
        </v-btn>
      </div>
    </v-alert>

    <!-- Empty State -->
    <div v-else-if="saldosFiltrados.length === 0" class="text-center pa-8">
      <v-icon color="grey" size="64" class="mb-4">mdi-heart-pulse</v-icon>
      <div class="text-h5 grey--text text--darken-1 mb-2">Nenhum batimento detectado</div>
      <div class="text-body-1 grey--text">Dados de produção não disponíveis para esta ordem</div>
    </div>

    <!-- Main Dashboard -->
    <template v-else>
<!-- Header com informações da ordem -->
<v-card class="mb-4" elevation="3">
  <v-card-title class="d-flex align-center bg-grey-lighten-4 text-black">
    <v-icon size="32" class="mr-3">mdi-heart-pulse</v-icon>
    <div>

      <div class="text-subtitle-1 opacity-90">
         {{ saldosFiltradosComFiltros.length }} setores ativos
      </div>
    </div>

    <v-spacer />

    <!-- Grupo de botões de ação -->
    <v-btn-toggle
      v-model="abaToggle"
      multiple
      class="mr-4"
      tile
      dense
      border
      background-color="primary-lighten-5"
    >
      <v-btn
        value="filtros"
        variant="text"
        color="primary"
        class="mx-1"
        @click="mostrarFiltros = !mostrarFiltros"
      >
        <v-icon left size="18">
          {{ mostrarFiltros ? 'mdi-filter-minus' : 'mdi-filter' }}
        </v-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Mostrar Filtros' }}
      </v-btn>
      <v-divider vertical />
      <v-btn
        value="alertas"
        variant="text"
        color="primary"
        class="mx-1"
        @click="expandirAlertas = !expandirAlertas"
      >
        <v-icon left size="18">
          {{ expandirAlertas ? 'mdi-bell-minus' : 'mdi-bell-alert' }}
        </v-icon>
        {{ expandirAlertas ? 'Ocultar Alertas' : 'Mostrar Alertas' }}
      </v-btn>
    </v-btn-toggle>

    <!-- Status do Coração -->
    <v-chip
      :color="getStatusCoracao()"
      size="large"
      class="font-weight-bold"
      prepend-icon="mdi-heart"
      rounded
    >
      {{ getStatusTexto() }}
    </v-chip>
  </v-card-title>
</v-card>




      <!-- cards resumos -->
      <v-row class="mb-4">
        <!-- Meta Total -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="h-100 pa-4 metric-card borda-primary" flat>
            <div class="d-flex align-center mb-3">
              <v-avatar size="48" class="mr-3" color="primary-lighten-5">
                <v-icon color="primary" size="28">mdi-target</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 font-weight-bold primary--text">{{ totalPlanejadoFiltrado }}</div>
                <div class="text-caption">Meta Total</div>
              </div>
            </div>
            <v-divider class="my-2" />
            <v-progress-linear :model-value="(totalPlanejadoFiltrado / totalPlanejadoFiltrado) * 100" color="primary"
            height="6" rounded />
            <div class="text-caption text-end grey--text">
              {{ filtros.parte || filtros.tamanho ? 'Filtrado' : 'Geral' }}
            </div>
          </v-card>
        </v-col>

        <!-- Produzido -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="h-100 pa-4 metric-card borda-success" flat>
            <div class="d-flex align-center mb-3">
              <v-avatar size="48" class="mr-3" color="success-lighten-5">
                <v-icon color="success" size="28">mdi-check-circle</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 font-weight-bold success--text">{{ totalProduzidoFiltrado }}</div>
                <div class="text-caption">Finalizado</div>
              </div>
            </div>
            <v-divider class="my-2" />
            <v-progress-linear :model-value="(totalProduzidoFiltrado / totalPlanejadoFiltrado) * 100" color="success"
              height="6" rounded />
          </v-card>
        </v-col>

        <!-- Restante -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="h-100 pa-4 metric-card borda-warning" flat>
            <div class="d-flex align-center mb-3">
              <v-avatar size="48" class="mr-3" color="warning-lighten-5">
                <v-icon color="warning" size="28">mdi-clock-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 font-weight-bold warning--text">{{ totalRestanteFiltrado }}</div>
                <div class="text-caption">Restante</div>
              </div>
            </div>
            <v-divider class="my-2" />
            <v-progress-linear :model-value="(totalRestanteFiltrado / totalPlanejadoFiltrado) * 100" color="warning"
            height="6" rounded />
            <div class="text-caption text-end grey--text">
              {{ ((totalRestanteFiltrado / (totalPlanejadoFiltrado - totalErrosFiltrado)) * 100).toFixed(1) }}% pendente
            </div>
          </v-card>
        </v-col>

        <!-- Erros -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="h-100 pa-4 metric-card" :class="totalErrosFiltrado > 0 ? 'borda-error' : 'borda-success'" flat>
            <div class="d-flex align-center mb-3">
              <v-avatar size="48" class="mr-3"
                :color="totalErrosFiltrado > 0 ? 'error-lighten-5' : 'success-lighten-5'">
                <v-icon :color="totalErrosFiltrado > 0 ? 'error' : 'success'" size="28">
                  {{ totalErrosFiltrado > 0 ? 'mdi-alert-circle' : 'mdi-shield-check' }}
                </v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 font-weight-bold" :class="totalErrosFiltrado > 0 ? 'error--text' : 'success--text'">
                  {{ totalErrosFiltrado }}
                </div>
                <div class="text-caption">
                  {{ totalErrosFiltrado > 0 ? 'Erros' : 'Sem Erros' }}
                </div>
              </div>
            </div>
            <v-divider class="my-2" />
            <v-progress-linear :model-value="(totalErrosFiltrado / totalPlanejadoFiltrado) * 100" color="error"
            height="6" rounded />
            <div class="text-caption text-end grey--text">
              {{ totalErrosFiltrado > 0 ? ((totalErrosFiltrado / totalPlanejadoFiltrado) * 100).toFixed(1) + '% comerro' :'Qualidade OK' }}
            </div>
          </v-card>
        </v-col>
      </v-row>


      <!-- Painel de Filtros Avançados  e alertas-->
      <v-row v-if="mostrarFiltros || expandirAlertas">
        <v-col cols="12">
      <!-- Painel de Filtros Avançados -->
      <v-card v-if="mostrarFiltros" class="mb-4" elevation="2">
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2">mdi-filter-variant</v-icon>
          Filtros de Análise
          <v-spacer />
          <v-btn size="small" variant="outlined" @click="mostrarFiltros = !mostrarFiltros"
            :prepend-icon="mostrarFiltros ? 'mdi-chevron-up' : 'mdi-chevron-down'">
            {{ mostrarFiltros ? 'Ocultar' : 'Mostrar' }} Filtros
          </v-btn>
        </v-card-title>

        <v-expand-transition>
          <v-card-text v-if="mostrarFiltros">
            <v-row>
              <!-- Filtro por Parte -->
              <v-col cols="12" sm="6" md="3">
                <v-select v-model="filtros.parte" :items="partesDisponiveis" label="Filtrar por Parte" clearable
                  prepend-icon="mdi-puzzle" variant="outlined" density="compact">
                  <template v-slot:selection="{ item }">
                    <v-chip size="small" color="blue">{{ item.title }}</v-chip>
                  </template>
                </v-select>
              </v-col>

              <!-- Filtro por Tamanho -->
              <v-col cols="12" sm="6" md="3">
                <v-select v-model="filtros.tamanho" :items="tamanhosDisponiveis" label="Filtrar por Tamanho" clearable
                  prepend-icon="mdi-resize" variant="outlined" density="compact">
                  <template v-slot:selection="{ item }">
                    <v-chip size="small" color="green">{{ item.title }}</v-chip>
                  </template>
                </v-select>
              </v-col>

              <!-- Filtro por Status -->
              <v-col cols="12" sm="6" md="3">
                <v-select v-model="filtros.status" :items="statusDisponiveis" label="Filtrar por Status" clearable
                  prepend-icon="mdi-flag" variant="outlined" density="compact">
                  <template v-slot:selection="{ item }">
                    <v-chip size="small" :color="getChipColor(item.value)">{{ item.title }}</v-chip>
                  </template>
                </v-select>
              </v-col>

              <!-- Filtro por Setor -->
              <v-col cols="12" sm="6" md="3">
                <v-select v-model="filtros.setor" :items="setoresDisponiveis" label="Filtrar por Setor" clearable
                  prepend-icon="mdi-factory" variant="outlined" density="compact">
                  <template v-slot:selection="{ item }">
                    <v-chip size="small" :color="getCorSetor(item.value)">{{ item.title }}</v-chip>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <!-- Filtros Adicionais -->
            <v-row class="mt-2">
              <v-col cols="12" sm="6" md="4">
                <v-switch v-model="filtros.apenasComProducao" label="Apenas setores com produção" color="success"
                  density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-switch v-model="filtros.apenasComErros" label="Apenas setores com erros" color="error"
                  density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-switch v-model="filtros.apenasComPendencias" label="Apenas com pendências" color="warning"
                  density="compact" />
              </v-col>
            </v-row>

            <!-- Botões de Ação -->
            <div class="d-flex justify-end mt-4 gap-2">
              <v-btn variant="outlined" @click="limparFiltros" prepend-icon="mdi-filter-off">
                Limpar Filtros
              </v-btn>
              <v-btn color="primary" @click="aplicarFiltros" prepend-icon="mdi-magnify">
                Aplicar Análise
              </v-btn>
            </div>
          </v-card-text>
        </v-expand-transition>
      </v-card>
        </v-col>
        <v-col cols="12">
      <!-- Alertas Críticos de Tempo -->
      <v-row v-if="alertasCriticos.length > 0 && expandirAlertas" class="mb-4">
        <v-col cols="12">
          <v-card class="alert-critico elevation-2">
            <v-card-title class="d-flex align-center " style="background-color: rgb(255 164 181);">
              <v-icon class="mr-2 heartbeat">mdi-heart-broken</v-icon>
              Alertas Críticos - Atenção Imediata Necessária
              <v-spacer />
              <v-chip color="white" text-color="error" size="small">
                {{ alertasCriticos.length }} alerta(s)
              </v-chip>
              <v-btn variant="outlined" size="small" class="ml-2" @click="expandirAlertas = !expandirAlertas">
                {{ expandirAlertas ? 'Ocultar' : 'Mostrar' }} Alertas
              </v-btn>
            </v-card-title>

            <v-slide-y-transition>
              <v-card-text class="pa-0" v-show="expandirAlertas">
                <v-list lines="three">
                  <v-list-item v-for="(alerta, index) in alertasCriticos" :key="index" class="alerta-item">
                    <!-- Ícone de setor/alerta -->
                    <template v-slot:prepend>
                      <v-avatar size="40" :color="alerta.cor + '-lighten-4'">
                        <v-icon :color="alerta.cor">{{ alerta.icone }}</v-icon>
                      </v-avatar>
                    </template>

                    <!-- Título e descrição -->
                    <v-list-item-title class="font-weight-bold mb-1">
                      {{ alerta.titulo }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      <div>{{ alerta.descricao }}</div>
                      <div v-if="alerta.responsavel" class="mt-1">
                        <v-chip size="x-small" color="info" prepend-icon="mdi-account">
                          {{ alerta.responsavel }}
                        </v-chip>
                      </div>
                    </v-list-item-subtitle>

                    <!-- Tempo e data -->
                    <template v-slot:append>
                      <div class="d-flex flex-column align-end">
                        <v-chip :color="alerta.prioridadeCor" size="small" class="mb-1">
                          {{ alerta.tempoEspera }}
                        </v-chip>
                        <span class="text-caption grey--text">{{ alerta.dataFormatada }}</span>
                      </div>
                    </template>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-slide-y-transition>
          </v-card>
        </v-col>
      </v-row>

        </v-col>
      </v-row>





      <!-- Resumo dos Filtros Aplicados -->
      <div v-if="temFiltrosAtivos" class="mb-4">
        <v-card variant="outlined" class="filter-summary">
          <v-card-text class="pa-3">
            <div class="d-flex align-center flex-wrap gap-2">
              <span class="text-subtitle-2 mr-2">Filtros ativos:</span>

              <v-chip v-if="filtros.parte" size="small" color="blue" closable @click:close="filtros.parte = null">
                Parte: {{ filtros.parte }}
              </v-chip>

              <v-chip v-if="filtros.tamanho" size="small" color="green" closable @click:close="filtros.tamanho = null">
                Tamanho: {{ filtros.tamanho }}
              </v-chip>

              <v-chip v-if="filtros.status" size="small" :color="getChipColor(filtros.status)" closable
                @click:close="filtros.status = null">
                Status: {{ formatarStatus(filtros.status) }}
              </v-chip>

              <v-chip v-if="filtros.setor" size="small" :color="getCorSetor(filtros.setor)" closable
                @click:close="filtros.setor = null">
                Setor: {{ filtros.setor }}
              </v-chip>

              <v-spacer />

              <div class="text-caption grey--text">
                {{ saldosFiltradosComFiltros.length }} de {{ saldosFiltrados.length }} setores
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>



      <!-- Tabs de Visualização -->
      <v-tabs v-model="abaSelecionada" class="mb-4" color="primary">
        <v-tab value="setores">
          <v-icon class="mr-2">mdi-factory</v-icon>
          Setores
          <v-badge v-if="saldosFiltradosComFiltros.length !== saldosFiltrados.length"
            :content="saldosFiltradosComFiltros.length" color="primary" class="ml-5" />
        </v-tab>
        <v-tab value="timeline">
          <v-icon class="mr-2">mdi-timeline</v-icon>
          Timeline
          <v-badge v-if="movimentacoesFiltradas.length > 0" :content="movimentacoesFiltradas.length" color="info"
            class="ml-5" />
        </v-tab>
        <v-tab value="metricas">
          <v-icon class="mr-2">mdi-chart-box</v-icon>
          Análises
        </v-tab>
        <v-tab value="alertas">
          <v-icon class="mr-2">mdi-bell</v-icon>
          Alertas
          <v-badge v-if="alertas.length > 0" :content="alertas.length" color="error" class="ml-5" />
        </v-tab>
        <v-tab value="insights">
          <v-icon class="mr-2">mdi-lightbulb</v-icon>
          Insights
        </v-tab>
      </v-tabs>

      <!-- Conteúdo das Tabs -->
      <v-window v-model="abaSelecionada">
        <!-- Aba Setores -->
        <!-- Na aba Setores, modificar cada card do setor -->
        <v-window-item value="setores">
  <v-row>
    <v-col
      v-for="(setor, index) in setoresOrdenadosFiltrados"
      :key="index"
      cols="12"
      sm="12"
      lg="12"
    >
      <v-card
        class="h-100 setor-card"
        :class="getCardClass(setor)"
        elevation="2"
      >
        <!-- Título clicável -->
        <v-card-title
  class="py-3 px-4"
  style="
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
  "
  @click="expandedSetores[index] = !expandedSetores[index]"
>
  <!-- 1) Ícone -->
  <v-avatar :color="getCorSetor(setor.nome_setor)" size="32">
    <v-icon color="white">mdi-clipboard-list</v-icon>
  </v-avatar>

  <!-- 2) Nome do setor + chips de parte/tamanho -->
  <div style="flex: 1; display: flex; align-items: center; gap: 8px; min-width: 0;">
    <span
      class="text-subtitle-1 font-weight-bold"
      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
    >
      {{ setor.nome_setor }}
    </span>
    <v-chip dense small color="info" pill>{{ setor.parte || '—' }}</v-chip>
    <v-chip dense small color="success" pill>{{ setor.tamanho || '—' }}</v-chip>
  </div>

  <!-- 3) Indicadores numéricos -->
  <div style="display: flex; gap: 24px; margin-right: auto;">
    <!-- Recebido -->
    <div style="text-align: center;">
      <div class="text-h6 font-weight-bold">{{ setor.recebida_aprovada || 0 }}</div>
      <div class="text-caption grey--text">Rec.</div>
    </div>
    <!-- Produzido -->
    <div style="text-align: center;">
      <div class="text-h6 font-weight-bold">{{ setor.produzida || 0 }}</div>
      <div class="text-caption grey--text">Prod.</div>
    </div>
    <!-- Disponível -->
    <div style="text-align: center;">
      <div class="text-h6 font-weight-bold">{{ setor.saldo_disponivel_produzir || 0 }}</div>
      <div class="text-caption grey--text">Disp.</div>
    </div>
    <!-- Pendente -->
    <div style="text-align: center;">
      <div class="text-h6 font-weight-bold">{{ getQuantidadeAguardandoEnvio(setor) || 0 }}</div>
      <div class="text-caption grey--text">Pend.</div>
    </div>
  </div>

  <!-- 4) Status pill -->
  <v-chip
    :color="getChipColor(setor.status_geral)"
    dense
    small
    pill
    class="text-uppercase font-weight-medium mr-2"
  >
    {{ formatarStatus(setor.status_geral) }}
  </v-chip>

  <!-- 5) Toggle -->
  <v-btn icon variant="text" size="small" @click.stop="expandedSetores[index] = !expandedSetores[index]">
    <v-icon>{{ expandedSetores[index] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
  </v-btn>
</v-card-title>


        <!-- Conteúdo expansível -->
        <v-expand-transition>
          <v-card-text v-show="expandedSetores[index]" class="pt-0 px-4 pb-4">
            <!-- Responsável -->
            <div class="text-caption grey--text mb-3">
              {{ setor.funcionario_atual_nome || 'Sem responsável' }}
            </div>

            <!-- Progresso -->
            <div class="mb-4">
              <div class="d-flex justify-space-between align-center mb-1">
                <span class="text-body-2 font-weight-medium">Progresso</span>
                <span
                  class="text-h6 font-weight-bold"
                  :class="getProgressColorClass(calcularProgresso(setor))"
                >
                  {{ calcularProgresso(setor).toFixed(0) }}%
                </span>
              </div>
              <v-progress-linear
                :model-value="calcularProgresso(setor)"
                :color="getProgressColor(calcularProgresso(setor))"
                height="12"
                rounded
                striped
              />
            </div>

            <!-- Métricas -->
            <v-row dense class="mb-4">
              <v-col cols="3">
                <div class="text-center pa-2 bg-grey-lighten-4 rounded">
                  <div class="text-h6 font-weight-bold">{{ setor.recebida_aprovada || 0 }}</div>
                  <div class="text-caption">Recebido</div>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="text-center pa-2 bg-grey-lighten-4 rounded">
                  <div class="text-h6 font-weight-bold">{{ setor.produzida || 0 }}</div>
                  <div class="text-caption">Produzido</div>
                </div>
              </v-col>
              <v-col cols="3">
                <div
                  class="text-center pa-2 rounded"
                  :style="
                    setor.saldo_disponivel_produzir > 0
                      ? 'background-color: rgba(76, 175, 80, 0.1);'
                      : 'background-color: rgba(255, 0, 0, 0.1);'
                  "
                >
                  <div class="text-h6 font-weight-bold">{{ setor.saldo_disponivel_produzir || 0 }}</div>
                  <div class="text-caption">Disponível</div>
                </div>
              </v-col>
              <v-col cols="3">
                <div
                  class="text-center pa-2 rounded"
                  :style="
                    getQuantidadeAguardandoEnvio(setor) > 0
                      ? 'background-color: rgba(255, 0, 0, 0.1);'
                      : 'background-color: rgba(76, 175, 80, 0.1);'
                  "
                >
                  <div class="text-h6 font-weight-bold">{{ getQuantidadeAguardandoEnvio(setor) || 0 }}</div>
                  <div class="text-caption">Pendente Envio</div>
                </div>
              </v-col>
            </v-row>

            <!-- Ações -->
            <div class="d-flex gap-2">
              <v-btn
                size="small"
                color="primary"
                variant="outlined"
                @click="selecionarSetor(setor)"
                prepend-icon="mdi-eye"
                class="flex-grow-1"
              >
                Detalhes
              </v-btn>
              <v-btn
                size="small"
                color="success"
                variant="outlined"
                @click="gerarRelatorioSetor(setor)"
                prepend-icon="mdi-file-chart"
                class="flex-grow-1"
              >
                Relatório
              </v-btn>
            </div>
          </v-card-text>
        </v-expand-transition>
      </v-card>
    </v-col>
  </v-row>
</v-window-item>

        <!-- Aba Timeline -->
        <v-window-item value="timeline">
          <div class="timeline-wrapper">



            <v-card class="timeline-normal elevation-2">
              <v-card-title class="d-flex align-center " style="background-color: rgb(248 248 248);">
                <v-icon class="mr-2 text-blue-darken-2">mdi-timeline</v-icon>
                <span class="text-h6 font-weight-bold ">Linha do Tempo</span>
                <v-tooltip location="top" max-width="600">
                  <template #activator="{ props }">
                    <v-btn icon variant="text" size="small" v-bind="props" class="ml-2">
                      <v-icon>mdi-help-circle</v-icon>
                    </v-btn>
                  </template>
                  <div class="tooltip-content">
                    Aqui você pode acompanhar todas as movimentações do processo produtivo em ordem cronológica
                  </div>
                </v-tooltip>
                <v-spacer />
                <div class="d-flex gap-2 align-center">
                  <v-btn size="small" variant="outlined" @click="ordenarTimelineRecente = !ordenarTimelineRecente">
                    <v-icon start>{{ ordenarTimelineRecente ? 'mdi-sort-ascending' : 'mdi-sort-descending' }}</v-icon>
                    {{ ordenarTimelineRecente ? 'Mais Antigas' : 'Mais Recentes' }}
                  </v-btn>
                  <v-chip size="small" class="ml-5">
                    {{ movimentacoesFiltradas.length }} movimentações
                  </v-chip>
                </div>
              </v-card-title>
              <v-card-text>
                <!-- Conteúdo do Timeline -->
                <div class="timeline-content" style="height: 60vh; overflow-y: auto;">
                  <v-card elevation="2" class="timeline-card-container">
                    <v-card-text>
                      <div class="timeline-container">
                        <v-timeline align="start" side="end" density="comfortable" line-color="#1976D2"
                          class="timeline-with-line">
                          <v-timeline-item v-for="(mov, index) in movimentacoesOrdenadas" :key="index" size="small"
                            class="timeline-item-custom">
                            <!-- CARD DA DATA NA ESQUERDA  -->
                            <template #opposite>
                              <div :class="[{
                                'date-badge': true,
                                'date-badge-success': mov.data_autoricacao !== 'N/A',
                                'date-badge-warning': mov.data_autoricacao === 'N/A' && !mov.erro,
                                'date-badge-error': mov.erro
                              }]">
                                <div class="date-day">{{ mov && mov.data ? formatarDia(mov.data) : '??' }}</div>
                                <div class="date-month">{{ mov && mov.data ? formatarMes(mov.data) : '???' }}</div>
                                <v-chip size="small" class="mb-1 mt-3"> <v-icon size="12"
                                    class="mr-1">mdi-note-text</v-icon>
                                  {{ mov.data ? ` ${Math.ceil(Math.abs(new Date() - new Date(mov.data)) / (1000 * 60 *
                                  60 * 24))} dias` : '' }}
                                </v-chip>
                              </div>
                            </template>
                            <!-- CARD DE MOVIMENTAÇÃO PRINCIPAL -->
                            <div :class="['timeline-card-main',
                              mov.data_autoricacao !== 'N/A' ? 'border-success' :
                                mov.erro ? 'border-error' : 'border-warning']">
                              <div class="d-flex flex-wrap justify-space-between align-start h-100">
                                <!-- Conteúdo esquerdo -->
                                <div class="timeline-main-info pr-4">
                                  <!-- ...seu conteúdo... (chips, quantidade, setor, observações, responsável) -->
                                  <div class="d-flex align-center flex-wrap mb-2">
                                    <v-chip size="small" :color="mov.origem === mov.destino ? 'info' : 'primary'"
                                      class="mr-2 mb-1">
                                      De: {{ mov.origem }}
                                    </v-chip>
                                    <v-chip size="small" :color="mov.origem === mov.destino ? 'info' : 'warning'"
                                      class="mb-1">
                                      Para: {{ mov.destino }}
                                    </v-chip>
                                    <v-chip size="small" class="mb-1">

                                      <v-icon size="12" class="mr-1">mdi-calendar</v-icon>
                                      {{ formatarDataHora(mov.data) }}
                                    </v-chip>
                                    <v-chip size="small" class="mb-1">

                                      <v-icon size="14" class="mr-1">mdi-package</v-icon>
                                      Quantidade: {{ mov.quantidade }}
                                    </v-chip>
                                  </div>
                                  <div v-if="mov.observacao" class="text-caption mb-1">
  <span
    size="small"
    class="mb-1 observacao-chip"
    style="height: auto; white-space: pre-line; word-wrap: break-word; min-height: 32px;"
  >
    <v-icon size="12" class="mr-1">mdi-note-text</v-icon>
    <span style="white-space: pre-line; line-height: 1.4;">
      {{ mov.observacao }}
    </span>
  </span>
</div>
                                  <div v-if="mov.responsavel" class="text-caption">
                                    <v-chip size="x-small" color="info" prepend-icon="mdi-account">
                                      {{ mov.responsavel }}
                                    </v-chip>
                                  </div>
                                </div>
                                <!-- Status à direita -->
                                <div class="timeline-main-status text-right">
                                  <v-chip size="small" :color="mov.data_autoricacao !== 'N/A' ? 'success' : 'warning'"
                                    class="mb-1">
                                    {{ mov.data_autoricacao !== 'N/A' ? 'Autorizado' : 'Pendente' }}
                                  </v-chip>
                                  <div v-if="mov.data_autoricacao === 'N/A'"
                                    class="text-caption error--text font-weight-bold">
                                    Aguardando há {{ calcularTempoEsperaMovimentacao(mov.data) }}
                                  </div>
                                  <div v-else class="text-caption success--text">
                                    Autorizado em {{ formatarDataHora(mov.data_autoricacao) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-timeline-item>
                        </v-timeline>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-card-text>
            </v-card>



          </div>
        </v-window-item>

        <!-- Aba Métricas -->
        <v-window-item value="metricas">
          <v-row>
            <!-- Identificação de Gargalos -->
            <v-col cols="12" md="6">

              <v-card elevation="2" max-height="433" min-height="433" style="overflow-y: auto;">
                <v-card-title class="d-flex align-center sticky-card-title"
                  style="background-color: rgb(210 210 210) !important">



                  <span class="text-h6 font-weight-bold">Identificação de Gargalos</span>

                  <v-tooltip location="bottom" max-width="400">
                    <template v-slot:activator="{ props }">
                      <v-btn icon="mdi-help-circle" variant="text" size="small" v-bind="props" class="ml-2" />
                    </template>
                    <div class="tooltip-content">
                      <div class="font-weight-bold mb-2">Como é calculado:</div>
                      <div class="mb-2">
                        • <strong>Eficiência:</strong> (Produzido ÷ Planejado) × 100
                      </div>
                      <div class="mb-2">
                        • <strong>Gargalo:</strong> Setores com eficiência menor que 50% E que receberam material
                      </div>
                      <div class="mb-2">
                        • <strong>Impacto:</strong> Baseado na quantidade de itens parados
                      </div>
                      <div class="text-caption">
                        <strong>Objetivo:</strong> Identificar onde a produção está travando
                      </div>
                    </div>
                  </v-tooltip>
                </v-card-title>
                <v-card-text>
                  <div class="gargalos-analysis">
                    <div v-for="gargalo in gargalosIdentificados" :key="gargalo.setor" class="gargalo-item mb-3">
                      <div class="d-flex align-center justify-space-between mb-2">
                        <div class="d-flex align-center">
                          <v-avatar :color="gargalo.cor" size="32" class="mr-2">
                            <v-icon color="white" size="16">{{ gargalo.icone }}</v-icon>
                          </v-avatar>
                          <div>
                            <div class="font-weight-bold">{{ gargalo.setor }}</div>

                            <div class="text-caption grey--text">{{ gargalo.descricao }}</div>
                            <div v-if="gargalo.funcionario" class="text-caption">
                              <v-chip size="x-small" color="info">{{ gargalo.funcionario }}</v-chip>
                            </div>
                          </div>
                        </div>
                        <v-chip :color="gargalo.severidade" size="small">
                          {{ gargalo.impacto }}
                        </v-chip>
                      </div>
                      <v-progress-linear :model-value="gargalo.porcentagem" :color="gargalo.cor" height="6" rounded />
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Eficiência por Setor -->
            <v-col cols="12" md="6">
              <v-card elevation="2" max-height="433" style="overflow-y: auto;">
                <v-card-title class="d-flex align-center sticky-card-title"
                  style="background-color: rgb(210 210 210) !important">
                  <span class="text-h6 font-weight-bold">Eficiência por Setor</span>
                  <v-tooltip location="bottom" max-width="400">
                    <template v-slot:activator="{ props }">
                      <v-btn icon="mdi-help-circle" variant="text" size="small" v-bind="props" class="ml-2" />
                    </template>
                    <div class="tooltip-content">
                      <div class="font-weight-bold mb-2">Fórmula de Cálculo:</div>
                      <div class="mb-2">• <strong>Eficiência = (Produzido ÷ Planejado) × 100</strong></div>
                      <div class="mb-2">• <span class="success--text">Verde (≥75%):</span> Excelente</div>
                      <div class="mb-2">• <span class="warning--text">Laranja (50-74%):</span> Adequado</div>
                      <div class="mb-2">• <span class="error--text">Vermelho (&lt;50%):</span> Crítico</div>
                      <div class="text-caption"><strong>Meta:</strong> Manter todos os setores acima de 75%</div>
                    </div>
                  </v-tooltip>
                </v-card-title>

                <v-card-text>
                  <div class="d-flex flex-column gap-2">
                    <v-card v-for="setor in setoresComDadosFiltrados" :key="setor.nome_setor + setor.parte"
                      class="setor-chart-card pa-3" elevation="1">
                      <div class="d-flex justify-space-between align-center mb-1">
                        <div class="text-subtitle-2 font-weight-bold">
                          {{ setor.nome_setor }} <span v-if="setor.parte">- {{ setor.parte }}</span> <span
                            v-if="setor.tamanho">- {{ setor.tamanho }}</span>
                        </div>
                        <div class="text-caption">
                          {{ setor.produzida || 0 }}/{{ setor.planejada_inicial || 0 }}
                        </div>
                      </div>

                      <v-progress-linear :model-value="calcularProgresso(setor)"
                        :color="getChartBarStyle(calcularProgresso(setor)).backgroundColor" height="8" rounded
                        class="mb-1" />

                      <div class="d-flex justify-space-between align-center">
                        <v-chip size="x-small" color="blue-grey" v-if="setor.funcionario_atual_nome">
                          {{ setor.funcionario_atual_nome }}
                        </v-chip>
                        <span class="text-caption">{{ calcularProgresso(setor).toFixed(0) }}%</span>
                      </div>
                    </v-card>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>



            <!-- Análise de Tempo -->
            <v-col cols="12" md="6">

              <v-card elevation="2" max-height="433" style="overflow-y: auto;">
                <v-card-title class="d-flex align-center sticky-card-title"
                  style="background-color: rgb(210 210 210) !important">



                  <span class="text-h6 font-weight-bold">Análise de Tempo de Produção</span>



                  <v-tooltip location="bottom" max-width="400">
                    <template v-slot:activator="{ props }">
                      <v-btn icon="mdi-help-circle" variant="text" size="small" v-bind="props" class="ml-2" />
                    </template>
                    <div class="tooltip-content">
                      <div class="font-weight-bold mb-2">Como é calculado:</div>
                      <div class="mb-2">
                        • <strong>Tempo no Setor:</strong> Diferença entre primeira e última movimentação
                      </div>
                      <div class="mb-2">
                        • <strong>Velocidade:</strong> Baseada na eficiência atual
                      </div>
                      <div class="mb-2">
                        • <strong>Status:</strong>
                        <br>- Rápido: maior que 75% eficiência
                        <br>- Normal: 25-75% eficiência
                        <br>- Lento: menor que 25% eficiência
                      </div>
                      <div class="text-caption">
                        <strong>Objetivo:</strong> Identificar setores lentos para otimização
                      </div>
                    </div>
                  </v-tooltip>
                </v-card-title>
                <v-card-text>
                  <div class="tempo-analysis">
                    <v-list density="compact">
                      <v-list-item v-for="tempo in analiseTempos" :key="tempo.setor">
                        <template v-slot:prepend>
                          <v-avatar :color="tempo.cor" size="24">
                            <v-icon color="white" size="12">{{ tempo.icone }}</v-icon>
                          </v-avatar>
                        </template>

                        <v-list-item-title class="text-body-2">
                          {{ tempo.setor }}
                        </v-list-item-title>

                        <template v-slot:append>
                          <div class="text-right">
                            <div class="text-caption font-weight-bold">{{ tempo.tempo }}</div>
                            <div class="text-caption grey--text">{{ tempo.status }}</div>
                          </div>
                        </template>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Previsão de Conclusão -->
            <v-col cols="12" md="6">

              <v-card elevation="2" max-height="433" style="overflow-y: auto;">
                <v-card-title class="d-flex align-center sticky-card-title"
                  style="background-color: rgb(210 210 210) !important">

                  Previsão de Conclusão
                  <v-tooltip location="bottom" max-width="400" min-width="400" max-height="400" min-height="400">
                    <template v-slot:activator="{ props }">
                      <v-btn icon="mdi-help-circle" variant="text" size="small" v-bind="props" class="ml-2" />
                    </template>
                    <div class="tooltip-content">
                      <div class="font-weight-bold mb-2">Algoritmo de Previsão:</div>
                      <div class="mb-2">
                        • <strong>Ritmo Atual:</strong> Produção das últimas 24h
                      </div>
                      <div class="mb-2">
                        • <strong>Restante:</strong> Total - Produzido
                      </div>
                      <div class="mb-2">
                        • <strong>Previsão:</strong> Restante ÷ Ritmo Atual
                      </div>
                      <div class="mb-2">
                        • <strong>Risco de Atraso:</strong> Baseado em gargalos e pendências
                      </div>
                      <div class="text-caption">
                        <strong>Precisão:</strong> ±20% baseado em dados históricos
                      </div>
                    </div>
                  </v-tooltip>
                </v-card-title>
                <v-card-text>
                  <div class="previsao-analysis text-center">
                    <div class="mb-4">
                      <v-icon size="64" :color="getCorPrevisao()" class="mb-2">
                        {{ getIconePrevisao() }}
                      </v-icon>
                      <div class="text-h5 font-weight-bold" :class="getCorPrevisao() + '--text'">
                        {{ previsaoConclusao }}
                      </div>
                      <div class="text-body-2 grey--text">Previsão de conclusão</div>
                    </div>

                    <v-divider class="my-3" />

                    <div class="d-flex justify-space-around">
                      <div class="text-center">
                        <div class="text-h6 font-weight-bold success--text">{{ diasRestantes }}</div>
                        <div class="text-caption">Dias restantes</div>
                      </div>
                      <div class="text-center">
                        <div class="text-h6 font-weight-bold primary--text">{{ ritmoProducao }}</div>
                        <div class="text-caption">Peças/dia</div>
                      </div>
                      <div class="text-center">
                        <div class="text-h6 font-weight-bold warning--text">{{ probabilidadeAtraso }}%</div>
                        <div class="text-caption">Risco atraso</div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-window-item>

        <!-- Aba Alertas -->
        <!-- Aba Alertas -->
        <v-window-item value="alertas">


          <v-card class="alerta-linha-lateral elevation-2">
            <v-card-title class="d-flex align-center " style="background-color: rgb(248 248 248);">
              <v-icon class="mr-2 " color="red">mdi-alert</v-icon>
              <span class="text-h6 font-weight-bold ">Alertas Inteligente</span>




              <v-tooltip location="bottom" max-width="400">
                <template #activator="{ props }">
                  <v-btn icon variant="text" size="small" v-bind="props" class="ml-2">
                    <v-icon>mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <div class="tooltip-content">
                  <div class="font-weight-bold mb-2">Sistema de Alertas:</div>
                  <div class="mb-2">• <strong>Alta Prioridade:</strong> Erros críticos (>72h)</div>
                  <div class="mb-2">• <strong>Média Prioridade:</strong> Aprovações (24–72h)</div>
                  <div class="mb-2">• <strong>Baixa Prioridade:</strong> Paradas com material</div>
                  <div class="text-caption"><strong>Responsável:</strong> Funcionário do setor</div>
                </div>
              </v-tooltip>
            </v-card-title>

            <v-divider />

            <!-- Conteúdo com scroll -->
            <v-card-text class="alertas-content overflow-y-auto"> <!-- Ativa scroll vertical -->

              <div class="timeline-content" style="height: 60vh; overflow-y: auto;">

                <v-alert v-for="(alerta, i) in alertas" :key="i" :data-tipo="alerta.prioridade" :icon="alerta.icone"
                  class="alerta-item mb-3" border="start" elevation="1" dense>
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="font-weight-bold">{{ alerta.titulo }}</div>
                      <div class="text-body-2">{{ alerta.descricao }}</div>

                      <div v-if="alerta.responsavel" class="mt-2">
                        <v-chip size="small" color="info" prepend-icon="mdi-account-circle" class="mr-2">
                          {{ alerta.responsavel }}
                        </v-chip>
                        <v-chip size="small" color="primary" prepend-icon="mdi-phone"
                          @click="contatarResponsavel(alerta)">
                          Contatar
                        </v-chip>
                      </div>

                      <div v-if="alerta.sugestao" class="text-caption mt-1 font-italic">
                        💡 {{ alerta.sugestao }}
                      </div>
                    </div>

                    <div class="text-right">
                      <v-chip size="small" class="alerta-chip mb-1" :class="{
                        'chip-alta': alerta.prioridade === 'alta',
                        'chip-media': alerta.prioridade === 'media',
                        'chip-baixa': alerta.prioridade === 'baixa'
                      }">
                        {{ alerta.prioridade.toUpperCase() }}
                      </v-chip>
                      <div v-if="alerta.tempoEspera" class="text-caption">
                        {{ alerta.tempoEspera }}
                      </div>
                    </div>
                  </div>
                </v-alert>
              </div>

              <div v-if="alertas.length === 0" class="text-center pa-8">
                <v-icon size="64" color="success" class="mb-4 heartbeat">mdi-heart-pulse</v-icon>
                <div class="text-h6 success--text">Coração Saudável!</div>
                <div class="text-body-1 grey--text">Nenhum alerta crítico detectado</div>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>


        <!-- Aba Insights -->
        <v-window-item value="insights">
          <v-row>
            <!-- Insights Automáticos -->
            <v-col cols="12" md="12">
              <v-card elevation="2">
                <v-card-title class="d-flex align-center">
                  <v-icon class="mr-2">mdi-lightbulb</v-icon>
                  Insights Automáticos da IA

                  <v-tooltip location="bottom" max-width="400">
                    <template v-slot:activator="{ props }">
                      <v-btn icon="mdi-help-circle" variant="text" size="small" v-bind="props" class="ml-2" />
                    </template>
                    <div class="tooltip-content">
                      <div class="font-weight-bold mb-2">Insights Automáticos:</div>
                      <div class="mb-2">
                        • <strong>Análise de Padrões:</strong> Sistema identifica tendências nos dados
                      </div>
                      <div class="mb-2">
                        • <strong>Detecção de Anomalias:</strong> Identifica comportamentos fora do padrão
                      </div>
                      <div class="mb-2">
                        • <strong>Recomendações:</strong> Sugestões baseadas em melhores práticas
                      </div>
                      <div class="text-caption">
                        <strong>Atualização:</strong> Insights são recalculados a cada nova movimentação
                      </div>
                    </div>
                  </v-tooltip>
                </v-card-title>
                <v-divider class="my-2" />
                <v-card-text>
                  <v-list>
                    <v-list-item v-for="(insight, index) in insightsAutomaticos" :key="index" class="mb-2">
                      <template v-slot:prepend>
                        <v-avatar :color="insight.cor" size="40">
                          <v-icon color="white">{{ insight.icone }}</v-icon>
                        </v-avatar>
                      </template>

                      <v-list-item-title class="font-weight-bold">
                        {{ insight.titulo }}
                      </v-list-item-title>

                      <v-list-item-subtitle class="mt-1">
                        {{ insight.descricao }}
                      </v-list-item-subtitle>

                      <div v-if="insight.acao" class="mt-2">
                        <v-chip size="small" :color="insight.cor" variant="outlined">
                          🎯 {{ insight.acao }}
                        </v-chip>
                      </div>

                      <!-- Funcionários Envolvidos -->
                      <div v-if="insight.funcionarios && insight.funcionarios.length > 0" class="mt-2">
                        <div class="text-caption mb-1">Funcionários envolvidos:</div>
                        <div class="d-flex flex-wrap gap-1">
                          <v-chip v-for="funcionario in insight.funcionarios" :key="funcionario" size="x-small"
                            color="blue-grey" variant="outlined">
                            {{ funcionario }}
                          </v-chip>
                        </div>
                      </div>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Resumo Executivo Melhorado -->
            <v-col cols="12" md="12">
              <v-card elevation="2">
                <v-card-title class="d-flex align-center bg-gradient-primary text-white">
                  <v-icon class="mr-2">mdi-chart-line</v-icon>
                  Resumo Executivo - Dashboard Gerencial
                  <v-tooltip location="bottom" max-width="400">
                    <template v-slot:activator="{ props }">
                      <v-btn icon="mdi-help-circle" variant="text" size="small" v-bind="props" class="ml-2"
                        color="white" />
                    </template>
                    <div class="tooltip-content">
                      <div class="font-weight-bold mb-2">Dashboard Gerencial:</div>
                      <div class="mb-2">
                        • <strong>Gráficos em Tempo Real:</strong> Visualização do progresso de cada setor
                      </div>
                      <div class="mb-2">
                        • <strong>Análise Comparativa:</strong> Planejado vs Produzido vs Meta
                      </div>
                      <div class="mb-2">
                        • <strong>Indicadores Visuais:</strong> Status colorido para identificação rápida
                      </div>
                      <div class="text-caption">
                        <strong>Objetivo:</strong> Visão executiva para tomada de decisões estratégicas
                      </div>
                    </div>
                  </v-tooltip>
                  <v-spacer />
                  <v-chip color="white" text-color="primary" size="small">
                    Atualizado: {{ formatarDataAtual() }}
                  </v-chip>
                </v-card-title>

                <v-card-text class="pa-0">
                  <!-- Métricas Principais em Cards -->
                  <div class="pa-4 bg-grey-lighten-5">
                    <v-row>
                      <v-col cols="12" sm="6" md="3">
                        <v-card class="text-center pa-3 metric-card-executive" color="blue-lighten-5" elevation="3">
                          <v-icon size="32" color="primary" class="mb-2">mdi-speedometer</v-icon>
                          <div class="text-h4 font-weight-bold primary--text">{{ eficienciaGeral.toFixed(1) }}%</div>
                          <div class="text-subtitle-2">Eficiência Geral</div>
                          <v-progress-linear :model-value="eficienciaGeral" :color="getStatusCoracao()" height="6"
                            rounded class="mt-2" />
                        </v-card>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <v-card class="text-center pa-3 metric-card-executive" color="green-lighten-5" elevation="3">
                          <v-icon size="32" color="success" class="mb-2">mdi-check-circle</v-icon>
                          <div class="text-h4 font-weight-bold success--text">{{ totalProduzidoFiltrado }}</div>
                          <div class="text-subtitle-2">Total Produzido</div>
                          <div class="text-caption mt-1">{{ ((totalProduzidoFiltrado / totalPlanejadoFiltrado) *
                            100).toFixed(1) }}% da meta</div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <v-card class="text-center pa-3 metric-card-executive" color="orange-lighten-5" elevation="3">
                          <v-icon size="32" color="warning" class="mb-2">mdi-clock-outline</v-icon>
                          <div class="text-h4 font-weight-bold warning--text">{{ totalRestanteFiltrado }}</div>
                          <div class="text-subtitle-2">Restante</div>
                          <div class="text-caption mt-1">{{ diasRestantes }} dias estimados</div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <v-card class="text-center pa-3 metric-card-executive"
                          :color="gargalosIdentificados.length > 0 ? 'red-lighten-5' : 'green-lighten-5'" elevation="3">
                          <v-icon size="32" :color="gargalosIdentificados.length > 0 ? 'error' : 'success'"
                            class="mb-2">
                            {{ gargalosIdentificados.length > 0 ? 'mdi-alert-circle' : 'mdi-shield-check' }}
                          </v-icon>
                          <div class="text-h4 font-weight-bold"
                            :class="gargalosIdentificados.length > 0 ? 'error--text' : 'success--text'">
                            {{ gargalosIdentificados.length }}
                          </div>
                          <div class="text-subtitle-2">{{ gargalosIdentificados.length > 0 ? 'Gargalos Ativos' : 'Sem Gargalos' }}</div>
                          <div class="text-caption mt-1">{{ probabilidadeAtraso }}% risco de atraso</div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>

                  <v-divider />

                  <!-- Gráficos por Setor -->


                  <div class="pa-4">


                    <!-- componente de gráfico -->
                    <div class="pa-4">

                      <SectorBarChart :setores="setoresComDadosFiltrados" />
                    </div>
                  </div>



                  <v-divider />

                  <!-- Análise Executiva -->
                  <div class="pa-4">
                    <v-row>
                      <!-- Gargalos e Ações -->
                      <v-col cols="12" md="6">
                        <div class="mb-4">
                          <div class="d-flex align-center mb-3">
                            <v-icon class="mr-2" color="error">mdi-alert-circle</v-icon>
                            <h4 class="text-subtitle-1 font-weight-bold">Principais Gargalos</h4>
                          </div>

                          <div v-if="top3Gargalos.length > 0">
                            <div v-for="(gargalo, index) in top3Gargalos" :key="gargalo"
                              class="d-flex align-center mb-2">
                              <v-chip size="small" :color="index === 0 ? 'error' : index === 1 ? 'warning' : 'info'"
                                class="mr-3">
                                {{ index + 1 }}º
                              </v-chip>
                              <div class="flex-grow-1">
                                <div class="text-body-2 font-weight-medium">{{ gargalo }}</div>
                                <div class="text-caption grey--text">
                                  {{gargalosIdentificados.find(g => g.setor === gargalo)?.descricao || 'Baixa eficiência' }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-else class="d-flex align-center">
                            <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                            <span class="text-body-2 success--text font-weight-medium">
                              ✅ Nenhum gargalo crítico identificado
                            </span>
                          </div>
                        </div>

                        <div class="mb-4">
                          <div class="d-flex align-center mb-3">
                            <v-icon class="mr-2" color="primary">mdi-target</v-icon>
                            <h4 class="text-subtitle-1 font-weight-bold">Ações Prioritárias</h4>
                          </div>

                          <div v-for="(acao, index) in acoesRecomendadas.slice(0, 3)" :key="acao"
                            class="d-flex align-center mb-2">
                            <v-chip size="small" color="primary" class="mr-3">{{ index + 1 }}</v-chip>
                            <span class="text-body-2">{{ acao }}</span>
                          </div>
                        </div>
                      </v-col>

                      <!-- Funcionários e Status -->
                      <v-col cols="12" md="6">
                        <div class="mb-4">
                          <div class="d-flex align-center mb-3">
                            <v-icon class="mr-2" color="info">mdi-account-group</v-icon>
                            <h4 class="text-subtitle-1 font-weight-bold">Funcionários Chave</h4>
                          </div>

                          <div class="d-flex flex-wrap gap-2">
                            <v-chip v-for="funcionario in funcionariosChave.slice(0, 6)" :key="funcionario.nome"
                              size="small" :color="funcionario.cor" variant="outlined">
                              {{ funcionario.nome }}
                            </v-chip>
                          </div>
                        </div>

                        <div class="mb-4">
                          <div class="d-flex align-center mb-3">
                            <v-icon class="mr-2" color="success">mdi-chart-timeline-variant</v-icon>
                            <h4 class="text-subtitle-1 font-weight-bold">Previsão de Entrega</h4>
                          </div>

                          <v-card variant="outlined" class="pa-3">
                            <div class="d-flex justify-space-between align-center">
                              <div>
                                <div class="text-h6 font-weight-bold" :class="getCorPrevisao() + '--text'">
                                  {{ previsaoConclusao }}
                                </div>
                                <div class="text-caption grey--text">Estimativa de conclusão</div>
                              </div>
                              <v-icon size="32" :color="getCorPrevisao()">{{ getIconePrevisao() }}</v-icon>
                            </div>

                            <v-divider class="my-2" />

                            <div class="d-flex justify-space-around text-center">
                              <div>
                                <div class="text-subtitle-2 font-weight-bold">{{ ritmoProducao }}</div>
                                <div class="text-caption">peças/dia</div>
                              </div>
                              <div>
                                <div class="text-subtitle-2 font-weight-bold">{{ probabilidadeAtraso }}%</div>
                                <div class="text-caption">risco</div>
                              </div>
                            </div>
                          </v-card>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <v-divider />

                  <!-- Botão de Ação Principal -->
                  <div class="pa-4 text-center bg-grey-lighten-5">
                    <v-btn color="primary" @click="gerarRelatorioCompleto" prepend-icon="mdi-file-pdf" size="large"
                      class="mb-2" elevation="3">
                      Gerar Relatório Executivo Completo
                    </v-btn>
                    <div class="text-caption grey--text">
                      Relatório detalhado com todos os setores, gráficos e análises para apresentação executiva
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-window-item>



      </v-window>
    </template>

    <!-- Modal de Detalhes do Setor -->
    <v-dialog v-model="modalSetor" max-width="1000px">
      <v-card v-if="setorSelecionado">
        <v-card-title class="d-flex align-center bg-primary text-white">
          <v-avatar :color="getCorSetor(setorSelecionado.nome_setor)" class="mr-3">
            <v-icon color="white">{{ getIconeSetor(setorSelecionado.nome_setor) }}</v-icon>
          </v-avatar>
          <div>
            <div class="text-h6">{{ setorSelecionado.nome_setor }}</div>
            <div class="text-subtitle-2 opacity-90">
              {{ setorSelecionado.funcionario_atual_nome || 'Sem responsável' }}
            </div>
          </div>
          <v-spacer />
          <v-btn color="white" variant="outlined" class="mr-2" @click="gerarRelatorioSetor(setorSelecionado)"
            prepend-icon="mdi-file-chart">
            Relatório ##
          </v-btn>
          <v-btn icon variant="text" @click="modalSetor = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <!-- Métricas Detalhadas -->
          <v-row class="mb-4">
            <v-col cols="6" md="2">
              <v-card variant="elevated">
                <v-card-text class="text-center pa-3">
                  <div class="text-h6 font-weight-bold">{{ setorSelecionado.planejada_inicial || 0 }}</div>
                  <div class="text-caption">Planejado</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" md="2">
              <v-card variant="elevated">
                <v-card-text class="text-center pa-3">
                  <div class="text-h6 font-weight-bold success--text">{{ setorSelecionado.recebida_aprovada || 0 }}
                  </div>
                  <div class="text-caption">Recebido</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" md="2">
              <v-card variant="elevated">
                <v-card-text class="text-center pa-3">
                  <div class="text-h6 font-weight-bold info--text">{{ setorSelecionado.produzida || 0 }}</div>
                  <div class="text-caption">Produzido</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" md="2">
              <v-card variant="elevated">
                <v-card-text class="text-center pa-3">
                  <div class="text-h6 font-weight-bold warning--text">{{ setorSelecionado.saldo_disponivel_produzir || 0
                    }}
                  </div>
                  <div class="text-caption">Disponível</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" md="2">
              <v-card variant="elevated">
                <v-card-text class="text-center pa-3">
                  <div class="text-h6 font-weight-bold primary--text">{{ setorSelecionado.transito || 0 }}</div>
                  <div class="text-caption">Em Trânsito</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" md="2">
              <v-card variant="elevated">
                <v-card-text class="text-center pa-3">
                  <div class="text-h6 font-weight-bold error--text">{{ setorSelecionado.setor_finalizado_com_erro || 0
                    }}
                  </div>
                  <div class="text-caption">Erros</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Movimentações Detalhadas -->
          <div class="mb-4">
            <h3 class="mb-2">Histórico Completo de Movimentações</h3>
            <v-timeline density="compact">
              <v-timeline-item v-for="(mov, index) in setorSelecionado.movimentacoes || []" :key="index"
                :dot-color="getCorMovimentacao(mov)" size="small">
                <template v-slot:opposite>
                  <div class="text-right">
                    <div class="text-body-2 font-weight-bold">{{ formatarDataHora(mov.data) }}</div>
                    <div class="text-caption grey--text">{{ calcularTempoDecorrido(mov.data) }}</div>
                  </div>
                </template>

                <v-card class="timeline-card" elevation="1" style="min-width: 600px;">
                  <v-card-text class="pa-3">
                    <div class="d-flex align-center justify-space-between">
                      <div class="flex-grow-1">
                        <div class="d-flex align-center mb-1">
                          <v-icon size="16" class="mr-1" :color="getCorMovimentacao(mov)">
                            {{ mov.data_autoricacao !== 'N/A' ? 'mdi-check-circle' : 'mdi-clock-alert' }}
                          </v-icon>




                          <v-chip size="small" class="mr-1" :color="getCorSetor(mov.origem)" label>
                            {{ mov.origem }}
                          </v-chip>
                          <v-icon size="14" class="mx-1">mdi-arrow-right</v-icon>
                          <v-chip size="small" class="ml-1" :color="getCorSetor(mov.destino)" label>
                            {{ mov.destino }}
                          </v-chip>




                        </div>


                        <div class="text-body-2 mb-1">
                          <v-icon size="14" class="mr-1">mdi-package</v-icon>
                          Data : {{ formatarDataHora(mov.data) }}
                        </div>


                        <div class="text-body-2 mb-1">
                          <v-icon size="14" class="mr-1">mdi-package</v-icon>
                          Quantidade: {{ mov.quantidade }}
                        </div>

                        <div v-if="mov.observacao" class="text-caption mb-1">
                          <v-icon size="12" class="mr-1">mdi-note-text</v-icon>
                          {{ mov.observacao }}
                        </div>

                        <div class="text-caption grey--text">
                          ID: {{ mov.id }} |
                          Cadastrado por: {{ mov.id_chefe_cadastro || 'Sistema' }}
                        </div>
                      </div>

                      <div class="text-right ml-3">
                        <v-chip size="small" :color="mov.data_autoricacao !== 'N/A' ? 'success' : 'warning'"
                          class="mb-1">
                          {{ mov.data_autoricacao !== 'N/A' ? 'Autorizado' : 'Pendente' }}
                        </v-chip>

                        <div v-if="mov.data_autoricacao === 'N/A'" class="text-caption error--text font-weight-bold">
                          ⏰ {{ calcularTempoEsperaMovimentacao(mov.data) }}
                        </div>

                        <div v-else class="text-caption success--text">
                          ✅ {{ formatarDataHora(mov.data_autoricacao) }}
                          <div class="text-caption grey--text">
                            Por: {{ mov.id_chefe_autorizou || 'Sistema' }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>


              </v-timeline-item>
            </v-timeline>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>



    <RelatorioCoracao v-model:dialog-relatorio="mostrarRelatorio" :dados-relatorio="dadosRelatorioCompleto"
      @relatorio-exportado="handleRelatorioExportado" @email-enviado="handleEmailEnviado" />
  </div>





</template>

<script>
import { producaoService } from '@/services/producaoService';
import RelatorioCoracao from './RelatorioCoracao.vue';
import SectorBarChart from '@/components/SectorBarChart.vue'

export default {
  components: {
    RelatorioCoracao,
    SectorBarChart
  },
  name: "Coracao",

  props: {
    idOrdem: {
      type: [Number, String],
      default: null
    },
    saldos: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {

      expandirAlertas: false,
      expandedSetores: [],

      mostrarRelatorio: false,
      dadosRelatorioCompleto: {},


      dadosOrdem: null,
      saldosCarregados: [],
      carregando: false,
      erro: null,
      abaSelecionada: 'setores',
      mostrarFiltros: false,
      modalSetor: false,
      setorSelecionado: null,
      ordenarTimelineRecente: true,

      // Filtros
      filtros: {
        parte: null,
        tamanho: null,
        status: null,
        setor: null,
        apenasComProducao: false,
        apenasComErros: false,
        apenasComPendencias: false
      }
    };
  },

  computed: {


    analiseTempos() {
      try {
        // 1. Agrupar os saldos por nome_setor e parte para consolidar os dados
        const aggregatedBySetorParte = new Map();

        // Verificar se saldosFiltradosComFiltros existe e é um array
        if (!this.saldosFiltradosComFiltros || !Array.isArray(this.saldosFiltradosComFiltros)) {
          console.warn('saldosFiltradosComFiltros não está definido ou não é um array');
          return [];
        }

        this.saldosFiltradosComFiltros.forEach(setor => {
          if (!setor) return;

          // Cria uma chave única combinando o nome do setor e a parte.
          const key = `${setor.nome_setor || 'unknown'}-${setor.parte || 'N/A'}`;

          if (!aggregatedBySetorParte.has(key)) {
            aggregatedBySetorParte.set(key, {
              nome_setor: setor.nome_setor || 'unknown',
              parte: setor.parte,
              planejada_inicial: 0,
              produzida: 0,
              movimentacoes: [], // Coleta todas as movimentações para este grupo SETOR-PARTE
            });
          }
          const currentAgg = aggregatedBySetorParte.get(key);
          currentAgg.planejada_inicial += (parseInt(setor.planejada_inicial) || 0);
          currentAgg.produzida += (parseInt(setor.produzida) || 0);
          if (setor.movimentacoes && Array.isArray(setor.movimentacoes)) {
            currentAgg.movimentacoes = currentAgg.movimentacoes.concat(setor.movimentacoes);
          }
        });

        // 2. Mapear os dados agregados para o formato final da análise de tempo
        return Array.from(aggregatedBySetorParte.values()).map(aggregatedSetor => {
          const progresso = (aggregatedSetor.planejada_inicial > 0) ?
            (aggregatedSetor.produzida / aggregatedSetor.planejada_inicial) * 100 : 0;
          let tempo = 'N/A';
          let status = 'Sem dados';
          let cor = 'grey';
          let icone = 'mdi-clock';

          if (aggregatedSetor.movimentacoes && aggregatedSetor.movimentacoes.length > 0) {
            // Ordenar as movimentações por data
            const sortedMovs = [...aggregatedSetor.movimentacoes].sort((a, b) => {
              return new Date(a.data || 0) - new Date(b.data || 0);
            });

            if (sortedMovs.length > 0 && sortedMovs[0] && sortedMovs[0].data) {
              tempo = this.calcularTempoDecorrido(sortedMovs[0].data);

              if (progresso > 75) {
                status = 'Rápido';
                cor = 'success';
                icone = 'mdi-speedometer';
              } else if (progresso > 25) {
                status = 'Normal';
                cor = 'primary';
                icone = 'mdi-speedometer-medium';
              } else {
                status = 'Lento';
                cor = 'error';
                icone = 'mdi-speedometer-slow';
              }
            }
          }

          // Formatar o nome do setor para incluir a parte
          const displaySetorName = `${aggregatedSetor.nome_setor}${aggregatedSetor.parte ? ' - ' + aggregatedSetor.parte : ''}`;

          return {
            setor: displaySetorName,
            tempo,
            status,
            cor,
            icone
          };
        });
      } catch (error) {
        console.error('Erro ao calcular análise de tempos:', error);
        return [];
      }
    },




    saldosFiltrados() {
      const dados = this.saldos?.length > 0 ? this.saldos : this.saldosCarregados;
      return dados.filter(item => item && item.nome_setor);
    },

    saldosFiltradosComFiltros() {
      let dados = [...this.saldosFiltrados];

      if (this.filtros.parte) {
        dados = dados.filter(item => item.parte === this.filtros.parte);
      }

      if (this.filtros.tamanho) {
        dados = dados.filter(item => item.tamanho === this.filtros.tamanho);
      }

      if (this.filtros.status) {
        dados = dados.filter(item => item.status_geral === this.filtros.status);
      }

      if (this.filtros.setor) {
        dados = dados.filter(item => item.nome_setor === this.filtros.setor);
      }

      if (this.filtros.apenasComProducao) {
        dados = dados.filter(item => (item.produzida || 0) > 0);
      }

      if (this.filtros.apenasComErros) {
        dados = dados.filter(item => (item.setor_finalizado_com_erro || 0) > 0);
      }

      if (this.filtros.apenasComPendencias) {
        dados = dados.filter(item => (item.recebida_aguardando_aprovocao || 0) > 0);
      }

      return dados;
    },

    partesDisponiveis() {
      const partes = [...new Set(this.saldosFiltrados.map(s => s.parte).filter(Boolean))];
      return partes.map(parte => ({ title: parte, value: parte }));
    },

    tamanhosDisponiveis() {
      const tamanhos = [...new Set(this.saldosFiltrados.map(s => s.tamanho).filter(Boolean))];
      return tamanhos.map(tamanho => ({ title: tamanho, value: tamanho }));
    },

    statusDisponiveis() {
      const status = [...new Set(this.saldosFiltrados.map(s => s.status_geral).filter(Boolean))];
      return status.map(st => ({ title: this.formatarStatus(st), value: st }));
    },

    setoresDisponiveis() {
      const setores = [...new Set(this.saldosFiltrados.map(s => s.nome_setor).filter(Boolean))];
      return setores.map(setor => ({ title: setor, value: setor }));
    },

    temFiltrosAtivos() {
      return this.filtros.parte || this.filtros.tamanho || this.filtros.status ||
        this.filtros.setor || this.filtros.apenasComProducao ||
        this.filtros.apenasComErros || this.filtros.apenasComPendencias;
    },

    setoresOrdenadosFiltrados() {
      return [...this.saldosFiltradosComFiltros].sort((a, b) => {
        const ativA = (a.produzida || 0) + (a.recebida_aprovada || 0);
        const ativB = (b.produzida || 0) + (b.recebida_aprovada || 0);
        return ativB - ativA;
      });
    },

    setoresComDadosFiltrados() {
      return this.saldosFiltradosComFiltros.filter(s => s.planejada_inicial > 0);
    },

    // setor com dados agrupos pelo setor e parte ok mais nao teste ainda
    setoresComDadosFiltradosPorSetorParte() {
      const setoresAgrupados = this.saldosFiltradosComFiltros.reduce((map, item) => {
        const key = `${item.nome_setor || 'unknown'}-${item.parte || 'N/A'}`;
        if (!map.has(key)) {
          map.set(key, {
            nome_setor: item.nome_setor,
            parte: item.parte,
            planejada_inicial: 0,
            produzida: 0,
            movimentacoes: [],
          });
        }
        const current = map.get(key);
        current.planejada_inicial += (item.planejada_inicial || 0);
        current.produzida += (item.produzida || 0);
        if (item.movimentacoes && Array.isArray(item.movimentacoes)) {
          current.movimentacoes = current.movimentacoes.concat(item.movimentacoes);
        }
        return map;
      }, new Map());
      return Array.from(setoresAgrupados.values()).filter(s => s.planejada_inicial > 0);
    },
    totalPlanejadoFiltrado() {
      return this.dadosOrdem?.total_quantidade_planejada ||
        this.saldosFiltradosComFiltros.reduce((total, item) => total + (item.planejada_inicial || 0), 0);
    },

    // que ja foi finalizado com sucesso
    totalProduzidoFiltradoFinalizado() {
      return this.saldosFiltradosComFiltros
        .filter(item => item.status_geral === 'Finalizado com sucesso' && item.id_setor === 19)
        .reduce((total, item) => total + (item.produzida || 0), 0);
    },

    // que ainda esta em andamento mais ja foi produzido
    totalProduzidoFiltrado() {
      return this.dadosOrdem?.total_quantidade_planejada ||
        this.saldosFiltradosComFiltros.reduce((total, item) => total + (item.produzida || 0), 0);

    },

    totalRestanteFiltrado() {
      return this.totalPlanejadoFiltrado - this.totalProduzidoFiltrado - this.totalErrosFiltrado;
    },

    totalErrosFiltrado() {
      return this.dadosOrdem?.quantidade_com_erro ||
        this.saldosFiltradosComFiltros.reduce((total, item) => total + (item.setor_finalizado_com_erro || 0), 0);
    },

    movimentacoesFiltradas() {
      const movimentacoes = [];
      this.saldosFiltradosComFiltros.forEach(setor => {
        if (setor.movimentacoes) {
          setor.movimentacoes.forEach(mov => {
            movimentacoes.push({
              ...mov,
              setor: setor.nome_setor,
              responsavel: setor.funcionario_atual_nome,
              data_formatada: new Date(mov.data)
            });
          });
        }
      });
      return movimentacoes;
    },

    movimentacoesOrdenadas() {
      const movs = [...this.movimentacoesFiltradas];
      return this.ordenarTimelineRecente
        ? movs.sort((a, b) => b.data_formatada - a.data_formatada)
        : movs.sort((a, b) => a.data_formatada - b.data_formatada);
    },

    alertasCriticos() {
      const alertas = [];
      const agora = new Date();

      this.saldosFiltradosComFiltros.forEach(setor => {
        if (setor.movimentacoes) {
          setor.movimentacoes.forEach(mov => {
            if (mov.data_autoricacao === 'N/A') {
              const dataMovimentacao = new Date(mov.data);
              const horasEspera = (agora - dataMovimentacao) / (1000 * 60 * 60);
              alertas.push({
                id: mov.id,
                tamanho: mov.tamanho,
                parte: mov.parte,
                titulo: `${setor.nome_setor} - Tamanho: ${mov.tamanho} Parte: ${mov.parte} - Autorização Crítica`,
                descricao: `Movimentação aguardando há ${Math.floor(horasEspera)} horas`,
                responsavel: setor.funcionario_atual_nome,
                cor: horasEspera > 72 ? 'error' : 'warning',
                icone: 'mdi-clock-alert',
                tempoEspera: this.calcularTempoEsperaMovimentacao(mov.data),
                dataFormatada: this.formatarDataHora(mov.data),
                prioridadeCor: horasEspera > 72 ? 'error' : 'warning'
              });

              if (horasEspera > 24) {
                alertas.push({
                  id: mov.id,
                  tamanho: mov.tamanho,
                  parte: mov.parte,
                  titulo: `${setor.nome_setor} - Autorização Crítica`,
                  descricao: `Movimentação aguardando há ${Math.floor(horasEspera)} horas`,
                  responsavel: setor.funcionario_atual_nome,
                  cor: horasEspera > 72 ? 'error' : 'warning',
                  icone: 'mdi-clock-alert',
                  tempoEspera: this.calcularTempoEsperaMovimentacao(mov.data),
                  dataFormatada: this.formatarDataHora(mov.data),
                  prioridadeCor: horasEspera > 72 ? 'error' : 'warning'
                });
              }
            }
          });
        }

        if (setor.saldo_disponivel_produzir > 0 && setor.produzida === 0) {
          alertas.push({
            titulo: `${setor.nome_setor} - Produção Parada`,
            descricao: `${setor.saldo_disponivel_produzir} itens disponíveis sem produção`,
            responsavel: setor.funcionario_atual_nome,
            cor: 'warning',
            icone: 'mdi-pause-circle',
            tempoEspera: 'Verificar imediatamente',
            dataFormatada: 'Status atual',
            prioridadeCor: 'warning'
          });
        }
      });

      return alertas.sort((a, b) => {
        const prioridadeA = a.cor === 'error' ? 3 : a.cor === 'warning' ? 2 : 1;
        const prioridadeB = b.cor === 'error' ? 3 : b.cor === 'warning' ? 2 : 1;
        return prioridadeB - prioridadeA;
      });
    },

    gargalosIdentificados() {
      try {
        // Verificar se saldosFiltradosComFiltros existe e é um array
        if (!this.saldosFiltradosComFiltros || !Array.isArray(this.saldosFiltradosComFiltros)) {
          console.warn('saldosFiltradosComFiltros não está definido ou não é um array');
          return [];
        }

        const gargalosMap = new Map(); // Usar um Map para armazenar gargalos únicos por setor

        this.saldosFiltradosComFiltros.forEach(setor => {
          if (!setor || !setor.nome_setor) return;

          // Usamos o nome_setor como chave primária
          const sectorKey = setor.nome_setor;

          // Inicializa ou recupera o gargalo para este setor
          let currentGargalo = gargalosMap.get(sectorKey);

          // Se não existe, cria um novo objeto gargalo
          if (!currentGargalo) {
            currentGargalo = {
              setor: setor.nome_setor,
              descricao: [], // Um array para coletar múltiplas razões de gargalo
              porcentagem: 0,
              cor: 'success',
              icone: 'mdi-check',
              severidade: 'info',
              impacto: 'Baixo',
              funcionario: setor.funcionario_atual_nome || 'Não atribuído',
              totalImpact: 0
            };
            gargalosMap.set(sectorKey, currentGargalo);
          }

          // Se descricao não for um array (possivelmente já convertido para string em alguma iteração), converta-o de volta para array
          if (!Array.isArray(currentGargalo.descricao)) {
            // Se já é uma string, transforme em array com um item
            if (typeof currentGargalo.descricao === 'string' && currentGargalo.descricao) {
              currentGargalo.descricao = [currentGargalo.descricao];
            } else {
              // Reinicia como array vazio em outros casos
              currentGargalo.descricao = [];
            }
          }

          // Calcula o progresso de forma segura
          const progresso = this.calcularProgresso(setor);

          // Condição 1: Baixa Eficiência
          const recebidaAprovada = parseInt(setor.recebida_aprovada) || 0;
          if (progresso < 50 && recebidaAprovada > 0) {
            currentGargalo.descricao.push(`Baixa eficiência: ${progresso.toFixed(0)}%`);
            // Define a maior severidade encontrada
            if (currentGargalo.severidade !== 'error') {
              currentGargalo.cor = 'error';
              currentGargalo.icone = 'mdi-speedometer-slow';
              currentGargalo.severidade = 'error';
              currentGargalo.impacto = 'Alto';
            }
            currentGargalo.totalImpact += (100 - progresso); // Quanto menor o progresso, maior o impacto
          }

          // Condição 2: Itens Aguardando Aprovação
          const recebidaAguardando = parseInt(setor.recebida_aguardando_aprovocao) || 0;
          if (recebidaAguardando > 0) {
            currentGargalo.descricao.push(`${recebidaAguardando} itens aguardando aprovação`);
            // Prioriza 'warning' se não for 'error' ainda
            if (currentGargalo.severidade !== 'error' && currentGargalo.severidade !== 'warning') {
              currentGargalo.cor = 'warning';
              currentGargalo.icone = 'mdi-clock-alert';
              currentGargalo.severidade = 'warning';
              currentGargalo.impacto = 'Médio';
            }
            currentGargalo.totalImpact += (recebidaAguardando * 0.5); // Adiciona impacto proporcional
          }
        });

        // Finalizar processamento: converter descrições para string e remover entradas sem problemas
        const gargalosFinalizados = [];
        gargalosMap.forEach((gargalo, key) => {
          if (gargalo.descricao.length > 0) {
            // Combina todas as descrições em uma única string apenas no final do processamento
            gargalo.descricao = gargalo.descricao.join('; ');
            gargalosFinalizados.push(gargalo);
          }
        });

        // Ordena pelo impacto total (maior primeiro) e pega os 5 primeiros
        return gargalosFinalizados
          .sort((a, b) => b.totalImpact - a.totalImpact)
          .slice(0, 5);
      } catch (error) {
        console.error('Erro ao identificar gargalos:', error);
        return [];
      }
    },

    eficienciaGeral() {
      return this.totalPlanejadoFiltrado > 0 ? (this.totalProduzidoFiltrado / this.totalPlanejadoFiltrado) * 100 : 0;
    },

    previsaoConclusao() {
      const progresso = this.eficienciaGeral;
      if (progresso >= 90) return 'Hoje';
      if (progresso >= 70) return '1-2 dias';
      if (progresso >= 50) return '3-5 dias';
      if (progresso >= 25) return '1 semana';
      return '2+ semanas';
    },

    diasRestantes() {
      const progresso = this.eficienciaGeral;
      if (progresso >= 90) return 0;
      if (progresso >= 70) return 2;
      if (progresso >= 50) return 4;
      if (progresso >= 25) return 7;
      return 14;
    },

    ritmoProducao() {
      return Math.round(this.totalProduzidoFiltrado / Math.max(1, this.diasRestantes || 1));
    },

    probabilidadeAtraso() {
      const progresso = this.eficienciaGeral;
      if (progresso >= 90) return 5;
      if (progresso >= 70) return 15;
      if (progresso >= 50) return 35;
      if (progresso >= 25) return 60;
      return 85;
    },

    insightsAutomaticos() {
      const insights = [];

      if (this.gargalosIdentificados.length > 0) {
        const gargalo = this.gargalosIdentificados[0];
        insights.push({
          titulo: 'Gargalo Identificado',
          descricao: `O setor ${gargalo.setor} está causando o maior impacto na produção`,
          acao: 'Priorizar recursos para este setor',
          cor: 'warning',
          icone: 'mdi-alert-circle',
          funcionarios: gargalo.funcionario ? [gargalo.funcionario] : []
        });
      }

      if (this.eficienciaGeral > 80) {
        insights.push({
          titulo: 'Excelente Performance',
          descricao: `A produção está ${this.eficienciaGeral.toFixed(0)}% eficiente, acima da meta`,
          acao: 'Manter o ritmo atual',
          cor: 'success',
          icone: 'mdi-trending-up'
        });
      } else if (this.eficienciaGeral < 50) {
        insights.push({
          titulo: 'Performance Baixa',
          descricao: `Eficiência de apenas ${this.eficienciaGeral.toFixed(0)}%, abaixo do esperado`,
          acao: 'Revisar processos e recursos',
          cor: 'error',
          icone: 'mdi-trending-down'
        });
      }

      const totalPendencias = this.saldosFiltradosComFiltros.reduce((total, s) => total + (s.recebida_aguardando_aprovocao || 0), 0);
      if (totalPendencias > 0) {
        const funcionariosComPendencias = this.saldosFiltradosComFiltros
          .filter(s => s.recebida_aguardando_aprovocao > 0)
          .map(s => s.funcionario_atual_nome)
          .filter(Boolean);

        insights.push({
          titulo: 'Aprovações Pendentes',
          descricao: `${totalPendencias} itens aguardando aprovação podem atrasar a produção`,
          acao: 'Acelerar processo de aprovação',
          cor: 'warning',
          icone: 'mdi-clock-alert',
          funcionarios: funcionariosComPendencias
        });
      }

      return insights;
    },

    top3Gargalos() {
      return this.gargalosIdentificados.slice(0, 3).map(g => g.setor);
    },

    acoesRecomendadas() {
      const acoes = [];

      if (this.alertasCriticos.length > 0) {
        acoes.push('Resolver aprovações pendentes');
      }

      if (this.eficienciaGeral < 70) {
        acoes.push('Otimizar setores com baixa eficiência');
      }

      if (this.gargalosIdentificados.length > 0) {
        acoes.push('Realocar recursos para gargalos');
      }

      return acoes.length > 0 ? acoes : ['Manter operação atual'];
    },

    funcionariosChave() {
      const funcionarios = [];

      this.gargalosIdentificados.forEach(gargalo => {
        if (gargalo.funcionario) {
          funcionarios.push({
            nome: gargalo.funcionario.split(' ')[0],
            cor: 'error'
          });
        }
      });

      this.saldosFiltradosComFiltros
        .filter(s => this.calcularProgresso(s) > 80 && s.funcionario_atual_nome)
        .forEach(s => {
          if (!funcionarios.find(f => f.nome === s.funcionario_atual_nome.split(' ')[0])) {
            funcionarios.push({
              nome: s.funcionario_atual_nome.split(' ')[0],
              cor: 'success'
            });
          }
        });

      return funcionarios.slice(0, 6);
    },

    alertas() {
      const alertas = [];

      this.saldosFiltradosComFiltros.forEach(setor => {


        if (setor.recebida_aguardando_aprovocao > 0) {
          const tempoEspera = this.calcularTempoEspera(setor);
          alertas.push({
            tipo: 'warning',
            icone: 'mdi-clock-alert',
            titulo: `${setor.nome_setor} - Aprovação Pendente`,
            descricao: `${setor.recebida_aguardando_aprovocao} itens aguardando aprovação`,
            responsavel: setor.funcionario_atual_nome,
            prioridade: 'media',
            tempoEspera: tempoEspera,
            sugestao: 'Contatar responsável pela aprovação'
          });
        }

        if (setor.saldo_disponivel_produzir > 0 && setor.produzida === 0) {
          alertas.push({
            tipo: 'info',
            icone: 'mdi-pause-circle',
            titulo: `${setor.nome_setor} - Produção Parada`,
            descricao: `${setor.saldo_disponivel_produzir} itens disponíveis mas sem produção`,
            responsavel: setor.funcionario_atual_nome,
            prioridade: 'baixa',
            sugestao: 'Verificar disponibilidade de recursos'
          });
        }
      });

      return alertas;
    }
  },

  watch: {
    idOrdem: {
      handler(newVal) {
        if (newVal && !this.saldos.length) {
          this.carregarDados();
        }
      },
      immediate: true
    }
  },

  mounted() {
    if (this.idOrdem && !this.saldos.length && !this.saldosCarregados.length) {
      this.carregarDados();
    }
  },

  methods: {
    formatarDia(data) {
      try {
        console.log('formatarDia - data recebida:', data);
        if (!data) return '??';

        // Tentar diferentes formatos de data
        let dataObj;

        // Verificar se a data já é um objeto Date
        if (data instanceof Date) {
          dataObj = data;
        } else {
          // Tentar converter string para Date
          if (typeof data === 'string') {
            // Tratar formato ISO (2023-10-25T14:30:00)
            if (data.includes('T')) {
              dataObj = new Date(data);
            }
            // Tratar formato DD/MM/YYYY
            else if (data.includes('/')) {
              const partes = data.split('/');
              if (partes.length === 3) {
                dataObj = new Date(`${partes[2]}-${partes[1]}-${partes[0]}`);
              } else {
                dataObj = new Date(data);
              }
            }
            // Outros formatos, deixar o JS tentar converter
            else {
              dataObj = new Date(data);
            }
          } else {
            // Caso seja timestamp numérico
            dataObj = new Date(data);
          }
        }

        if (isNaN(dataObj.getTime())) {
          console.error('Data inválida recebida em formatarDia:', data);
          return '??';
        }

        return dataObj.getDate().toString().padStart(2, '0');
      } catch (erro) {
        console.error('Erro ao formatar dia:', erro, 'para data:', data);
        return '??';
      }
    },

    formatarMes(data) {
      try {
        console.log('formatarMes - data recebida:', data);
        if (!data) return '???';

        const meses = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

        // Tentar diferentes formatos de data
        let dataObj;

        // Verificar se a data já é um objeto Date
        if (data instanceof Date) {
          dataObj = data;
        } else {
          // Tentar converter string para Date
          if (typeof data === 'string') {
            // Tratar formato ISO (2023-10-25T14:30:00)
            if (data.includes('T')) {
              dataObj = new Date(data);
            }
            // Tratar formato DD/MM/YYYY
            else if (data.includes('/')) {
              const partes = data.split('/');
              if (partes.length === 3) {
                dataObj = new Date(`${partes[2]}-${partes[1]}-${partes[0]}`);
              } else {
                dataObj = new Date(data);
              }
            }
            // Outros formatos, deixar o JS tentar converter
            else {
              dataObj = new Date(data);
            }
          } else {
            // Caso seja timestamp numérico
            dataObj = new Date(data);
          }
        }

        if (isNaN(dataObj.getTime())) {
          console.error('Data inválida recebida em formatarMes:', data);
          return '???';
        }

        return meses[dataObj.getMonth()];
      } catch (erro) {
        console.error('Erro ao formatar mês:', erro, 'para data:', data);
        return '???';
      }
    },

    // Obter status do setor baseado nos dados
    getStatusTexto(setor) {
      const progresso = this.calcularProgresso(setor);

      if (setor.setor_finalizado_com_erro > 0) return 'Com Erro';
      if (setor.status_geral === 'completa') return 'Concluído';
      if (progresso >= 100) return 'Concluído';
      if (progresso >= 75) return 'Avançado';
      if (progresso >= 25) return 'Em Progresso';
      if (setor.recebida_aprovada > 0) return 'Iniciado';
      if (setor.status_geral === 'sem') return 'Aguardando';
      return 'Pendente';
    },

    // Obter cor do status do setor
    getStatusCor(setor) {
      const status = this.getStatusTexto(setor);
      const cores = {
        'Concluído': 'success',
        'Avançado': 'info',
        'Em Progresso': 'primary',
        'Iniciado': 'warning',
        'Aguardando': 'grey',
        'Pendente': 'orange',
        'Com Erro': 'error'
      };
      return cores[status] || 'grey';
    },

    gerarRelatorio(setorEspecifico = null) {
      console.log('=== DEBUG GERAÇÃO RELATÓRIO ===');
      console.log('Gerando relatório', setorEspecifico ? `para o setor: ${setorEspecifico.nome_setor}` : 'para todos os setores');

      // Determinar quais setores incluir no relatório
      let setores;
      if (setorEspecifico) {
        setores = [setorEspecifico];
      } else {
        setores = this.saldosFiltradosComFiltros || [];
      }

      console.log('Setores para relatório:', setores.length);

      // Criar objeto de dados para o relatório
      this.dadosRelatorioCompleto = {
        ordem: this.dadosOrdem?.id || this.idOrdem,
        data: new Date().toLocaleString('pt-BR'),
        metricas: {
          planejado: setorEspecifico ? (setorEspecifico.planejada_inicial || 0) : this.totalPlanejadoFiltrado,
          produzido: setorEspecifico ? (setorEspecifico.produzida || 0) : this.totalProduzidoFiltrado,
          restante: setorEspecifico ? ((setorEspecifico.planejada_inicial || 0) - (setorEspecifico.produzida || 0)) : this.totalRestanteFiltrado,
          erros: setorEspecifico ? (setorEspecifico.setor_finalizado_com_erro || 0) : this.totalErrosFiltrado,
          eficiencia: setorEspecifico ? this.calcularProgresso(setorEspecifico).toFixed(1) : this.eficienciaGeral.toFixed(1)
        },
        setores: setores.map(setor => ({
          ...setor,
          // Garantir que todos os campos numéricos existam para evitar erros
          planejada_inicial: setor.planejada_inicial || 0,
          recebida_aprovada: setor.recebida_aprovada || 0,
          produzida: setor.produzida || 0,
          saldo_disponivel_produzir: setor.saldo_disponivel_produzir || 0,
          recebida_aguardando_aprovocao: setor.recebida_aguardando_aprovocao || 0
        })),
        gargalos: setorEspecifico ? [] : (this.gargalosIdentificados || []),
        alertas: setorEspecifico ? [] : (this.alertas || []),
        insights: setorEspecifico ? [] : (this.insightsAutomaticos || []),
        funcionarios: setorEspecifico ? [] : (this.funcionariosChave || []),
        acoes: setorEspecifico ? [] : (this.acoesRecomendadas || []),
        previsao: {
          conclusao: setorEspecifico ? 'Não aplicável para setor individual' : (this.previsaoConclusao || 'Não calculado'),
          diasRestantes: setorEspecifico ? 0 : (this.diasRestantes || 0),
          ritmo: setorEspecifico ? 0 : (this.ritmoProducao || 0),
          risco: setorEspecifico ? 0 : (this.probabilidadeAtraso || 0)
        },
        explicacao: setorEspecifico
          ? `Relatório detalhado do setor: ${setorEspecifico.nome_setor}`
          : 'Relatório baseado nos dados atuais de produção'
      };

      console.log('Dados do relatório montados:', this.dadosRelatorioCompleto);
      this.mostrarRelatorio = true;
    },


    handleRelatorioExportado(resultado) {
      console.log('Resultado da exportação:', resultado);

      if (resultado && resultado.sucesso) {
        // Implementar notificação de sucesso
        console.log(resultado.mensagem || `Relatório ${resultado.formato.toUpperCase()} exportado com sucesso!`);

        // Se você tiver um sistema de toast/notificação:
        // this.$toast.success(resultado.mensagem);

      } else {
        // Implementar notificação de erro
        const mensagemErro = resultado?.erro || resultado?.mensagem || 'Erro desconhecido ao exportar relatório';
        console.error('Erro na exportação:', mensagemErro);

        // Se você tiver um sistema de toast/notificação:
        // this.$toast.error(mensagemErro);
      }
    },


    handleEmailEnviado(resultado) {
      console.log('Resultado do envio de email:', resultado);

      if (resultado && resultado.sucesso) {
        console.log(resultado.mensagem || `Email enviado com sucesso!`);
        // this.$toast.success(resultado.mensagem);
      } else {
        const mensagemErro = resultado?.erro || resultado?.mensagem || 'Erro desconhecido ao enviar email';
        console.error('Erro no envio de email:', mensagemErro);
        // this.$toast.error(mensagemErro);
      }
    },


    async carregarDados() {
      if (!this.idOrdem) return;

      this.carregando = true;
      this.erro = null;

      try {
        const response = await producaoService.buscarProducaoPorIdOrdem(this.idOrdem);

        if (response && response.status === 'sucesso' && response.data && response.data.saldos) {
          this.saldosCarregados = response.data.saldos;
          this.dadosOrdem = {
            id: response.data.id_ordem,
            quantidade_planejada: response.data.quantidade_planejada,
            quantidade_com_erro: response.data.quantidade_com_erro,
            quantidade_planejada_disponivel: response.data.quantidade_planejada_disponivel,
            explicacao: response.data.explicacao
          };
        } else {
          this.erro = "Dados de produção não encontrados para esta ordem";
        }
      } catch (error) {
        console.error("Erro ao carregar dados de produção:", error);
        this.erro = `Erro ao carregar dados da produção: ${error.message}`;
      } finally {
        this.carregando = false;
      }
    },

    aplicarFiltros() {
      console.log('Filtros aplicados:', this.filtros);
    },

    limparFiltros() {
      this.filtros = {
        parte: null,
        tamanho: null,
        status: null,
        setor: null,
        apenasComProducao: false,
        apenasComErros: false,
        apenasComPendencias: false
      };
    },

    getQuantidadeAguardandoEnvio(setor) {
      const produzido = setor.produzida || 0;
      const enviado = setor.saidas || 0;
      return Math.max(0, produzido - enviado);
    },

    getAutorizacaoCardClass(tipo, setor) {
      if (tipo === 'enviar') {
        const aguardando = this.getQuantidadeAguardandoEnvio(setor);
        if (aguardando > 0) return 'border-warning';
        return 'border-success';
      } else {
        if ((setor.recebida_aguardando_aprovocao || 0) > 0) return 'border-warning';
        return 'border-success';
      }
    },

    calcularTempoEspera(setor) {
      if (!setor.movimentacoes || setor.movimentacoes.length === 0) return 'N/A';

      const movimentacoesPendentes = setor.movimentacoes.filter(m => m.data_autoricacao === 'N/A');
      if (movimentacoesPendentes.length === 0) return 'N/A';

      const maisAntiga = movimentacoesPendentes.reduce((antiga, atual) =>
        new Date(atual.data) < new Date(antiga.data) ? atual : antiga
      );

      return this.calcularTempoEsperaMovimentacao(maisAntiga.data);
    },

    calcularTempoEsperaMovimentacao(data) {
      const agora = new Date();
      const dataMovimentacao = new Date(data);
      const diffMs = agora - dataMovimentacao;

      const dias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const horas = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      if (dias > 0) return `${dias}d ${horas}h`;
      if (horas > 0) return `${horas}h`;
      return 'poucos minutos';
    },

    calcularTempoDecorrido(data) {
      const agora = new Date();
      const dataEvento = new Date(data);
      const diffMs = agora - dataEvento;

      const dias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const horas = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      if (dias > 0) return `há ${dias} dia(s)`;
      if (horas > 0) return `há ${horas} hora(s)`;
      return 'há poucos minutos';
    },

    formatarDataHora(data) {
      try {
        if (!data || data === 'N/A') return 'N/A';

        // Tentar diferentes formatos de data
        let dataObj;

        // Verificar se a data já é um objeto Date
        if (data instanceof Date) {
          dataObj = data;
        } else {
          // Tentar converter string para Date
          if (typeof data === 'string') {
            // Tratar formato ISO (2023-10-25T14:30:00)
            if (data.includes('T')) {
              dataObj = new Date(data);
            }
            // Tratar formato DD/MM/YYYY
            else if (data.includes('/')) {
              const partes = data.split('/');
              if (partes.length === 3) {
                dataObj = new Date(`${partes[2]}-${partes[1]}-${partes[0]}`);
              } else {
                dataObj = new Date(data);
              }
            }
            // Outros formatos, deixar o JS tentar converter
            else {
              dataObj = new Date(data);
            }
          } else {
            // Caso seja timestamp numérico
            dataObj = new Date(data);
          }
        }

        if (isNaN(dataObj.getTime())) {
          console.error('Data inválida recebida em formatarDataHora:', data);
          return 'Data inválida';
        }

        return dataObj.toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (erro) {
        console.error('Erro ao formatar data e hora:', erro, 'para data:', data);
        return 'Data inválida';
      }
    },

    getTimelineCardClass(mov) {
      if (mov.data_autoricacao === 'N/A') {
        const horasEspera = (new Date() - new Date(mov.data)) / (1000 * 60 * 60);
        if (horasEspera > 72) return 'border-error';
        if (horasEspera > 24) return 'border-warning';
      }
      return '';
    },

    getCorPrevisao() {
      const progresso = this.eficienciaGeral;
      if (progresso >= 80) return 'success';
      if (progresso >= 60) return 'primary';
      if (progresso >= 40) return 'warning';
      return 'error';
    },

    getIconePrevisao() {
      const progresso = this.eficienciaGeral;
      if (progresso >= 80) return 'mdi-rocket-launch';
      if (progresso >= 60) return 'mdi-speedometer';
      if (progresso >= 40) return 'mdi-clock-outline';
      return 'mdi-alert-circle';
    },

    contatarResponsavel(alerta) {
      if (alerta.responsavel) {
        console.log(`Contatar: ${alerta.responsavel}`);
        this.$emit('contatar-funcionario', {
          nome: alerta.responsavel,
          setor: alerta.titulo.split(' - ')[0],
          motivo: alerta.descricao
        });
      }
    },

    // O método gerarRelatorio foi consolidado acima e esta duplicação foi removida

    selecionarSetor(setor) {
      this.setorSelecionado = setor;
      this.modalSetor = true;
    },

    // Método para gerar relatório de um setor específico
    gerarRelatorioSetor(setor) {
      console.log('Gerando relatório para o setor:', setor.nome_setor);

      this.dadosRelatorioCompleto = {
        ordem: this.dadosOrdem?.id || this.idOrdem,
        data: new Date().toLocaleString('pt-BR'),
        metricas: {
          planejado: setor.planejada_inicial || 0,
          produzido: setor.produzida || 0,
          restante: (setor.planejada_inicial || 0) - (setor.produzida || 0),
          erros: setor.setor_finalizado_com_erro || 0,
          eficiencia: this.calcularProgresso(setor).toFixed(1)
        },
        setores: [setor], // Apenas este setor
        gargalos: [], // Vazio para relatório individual
        alertas: [], // Vazio para relatório individual
        insights: [], // Vazio para relatório individual
        funcionarios: setor.funcionario_atual_nome ? [{ nome: setor.funcionario_atual_nome.split(' ')[0], cor: 'primary' }] : [],
        acoes: [`Acompanhar progresso do setor ${setor.nome_setor}`],
        previsao: {
          conclusao: 'Análise individual de setor',
          diasRestantes: 0,
          ritmo: 0,
          risco: 0
        },
        explicacao: `Relatório detalhado específico do setor: ${setor.nome_setor}`
      };

      this.mostrarRelatorio = true;
    },

    // Método para gerar relatório completo (todos os setores)
    gerarRelatorioCompleto() {
      console.log('Gerando relatório completo de todos os setores');

      this.dadosRelatorioCompleto = {
        ordem: this.dadosOrdem?.id || this.idOrdem,
        data: new Date().toLocaleString('pt-BR'),
        metricas: {
          planejado: this.totalPlanejadoFiltrado,
          produzido: this.totalProduzidoFiltrado,
          restante: this.totalRestanteFiltrado,
          erros: this.totalErrosFiltrado,
          eficiencia: this.eficienciaGeral.toFixed(1)
        },
        setores: this.saldosFiltradosComFiltros.map(setor => ({
          ...setor,
          planejada_inicial: setor.planejada_inicial || 0,
          recebida_aprovada: setor.recebida_aprovada || 0,
          produzida: setor.produzida || 0,
          saldo_disponivel_produzir: setor.saldo_disponivel_produzir || 0,
          recebida_aguardando_aprovocao: setor.recebida_aguardando_aprovocao || 0
        })),
        gargalos: this.gargalosIdentificados || [],
        alertas: this.alertas || [],
        insights: this.insightsAutomaticos || [],
        funcionarios: this.funcionariosChave || [],
        acoes: this.acoesRecomendadas || [],
        previsao: {
          conclusao: this.previsaoConclusao || 'Não calculado',
          diasRestantes: this.diasRestantes || 0,
          ritmo: this.ritmoProducao || 0,
          risco: this.probabilidadeAtraso || 0
        },
        explicacao: 'Relatório completo com análise de todos os setores da ordem'
      };

      this.mostrarRelatorio = true;
    },

    // Manter o método gerarRelatorio original para compatibilidade
    gerarRelatorio(setorEspecifico = null) {
      if (setorEspecifico) {
        this.gerarRelatorioSetor(setorEspecifico);
      } else {
        this.gerarRelatorioCompleto();
      }
    },


    calcularProgresso(item) {
      const total = item.planejada_inicial || 0;
      const produzido = item.produzida || 0;
      return total > 0 ? (produzido / total) * 100 : 0;
    },

    getStatusCoracao() {
      const progresso = this.totalPlanejadoFiltrado > 0 ? (this.totalProduzidoFiltrado / this.totalPlanejadoFiltrado) * 100 : 0;
      if (progresso >= 90) return 'success';
      if (progresso >= 70) return 'info';
      if (progresso >= 50) return 'warning';
      return 'error';
    },

    getStatusTexto() {
      const progresso = this.totalPlanejadoFiltrado > 0 ? (this.totalProduzidoFiltrado / this.totalPlanejadoFiltrado) * 100 : 0;
      if (progresso >= 90) return 'Excelente';
      if (progresso >= 70) return 'Bom';
      if (progresso >= 50) return 'Regular';
      return 'Ruim';
    },

    getCardClass(setor) {
      const progresso = this.calcularProgresso(setor);
      if (progresso >= 75) return 'border-success';
      if (progresso >= 50) return 'border-warning';
      if (progresso > 0) return 'border-info';
      return 'border-grey';
    },

    getChartBarStyle(progresso) {
      let cor = '#F44336';
      if (progresso >= 75) cor = '#4CAF50';
      else if (progresso >= 50) cor = '#FF9800';

      return {
        width: `${progresso}%`,
        backgroundColor: cor,
        transition: 'width 0.8s ease'
      };
    },

    getChipColor(status) {
      const statusMap = {
        finalizado: "success",
        erro: "error",
        pendente: "warning",
        aprovado: "success",
        reprovado: "error",
        aguardando: "info",
        completa: "success",
        parcial: "warning",
        sem: "grey"
      };
      return statusMap[status?.toLowerCase()] || "grey";
    },

    getProgressColor(valor) {
      if (valor >= 100) return "success";
      if (valor >= 75) return "info";
      if (valor >= 50) return "primary";
      if (valor >= 25) return "warning";
      return "error";
    },

    getProgressColorClass(valor) {
      if (valor >= 100) return "success--text";
      if (valor >= 75) return "info--text";
      if (valor >= 50) return "primary--text";
      if (valor >= 25) return "warning--text";
      return "error--text";
    },

    formatarStatus(status) {
      if (!status) return "N/A";
      const statusMap = {
        'sem': 'Inativo',
        'pendente': 'Pendente',
        'completa': 'Completo',
        'parcial': 'Parcial'
      };
      return statusMap[status] || status.charAt(0).toUpperCase() + status.slice(1);
    },

    getCorSetor(nomeSetor) {
      const corMap = {
        'PCP': 'indigo',
        'ESTOQUE': 'green',
        'RISCO': 'orange',
        'CORTE': 'purple',
        'BORDADO': 'pink',
        'COSTURA': 'teal',
        'ACABAMENTO': 'blue',
        'EXPEDIÇÃO': 'brown',
        'RECUPERACAO': 'red',
        'ENTREGUE': 'success',
        'FINALIZADO ERRO': 'error'
      };
      return corMap[nomeSetor?.toUpperCase()] || "primary";
    },

    getIconeSetor(nomeSetor) {
      const iconeMap = {
        'PCP': 'mdi-clipboard-list',
        'ESTOQUE': 'mdi-package-variant',
        'RISCO': 'mdi-pencil-ruler',
        'CORTE': 'mdi-content-cut',
        'BORDADO': 'mdi-needle',
        'COSTURA': 'mdi-sewing-machine',
        'ACABAMENTO': 'mdi-package-variant-closed',
        'EXPEDIÇÃO': 'mdi-truck-delivery',
        'RECUPERACAO': 'mdi-wrench',
        'ENTREGUE': 'mdi-check-circle',
        'FINALIZADO ERRO': 'mdi-alert-circle'
      };
      return iconeMap[nomeSetor?.toUpperCase()] || "mdi-factory";
    },

    getCorMovimentacao(mov) {
      if (mov.data_autoricacao !== 'N/A') return 'success';

      const horasEspera = (new Date() - new Date(mov.data)) / (1000 * 60 * 60);
      if (horasEspera > 72) return 'error';
      if (horasEspera > 24) return 'warning';
      return 'info';
    },

    formatarDataAtual() {
      return new Date().toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
};
</script>

<style scoped>
.sticky-card-title {
  position: sticky;
  top: 0;
  background-color: white;
  /* Garante que o título tenha fundo */
  z-index: 1;
}


.coracao-producao {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 16px;
}

/* Filtros */
.filter-summary {
  background: linear-gradient(45deg, #e3f2fd 0%, #f3e5f5 100%);
}

/* Alertas Críticos */
.alert-critico {
  border-left: 5px solid #f44336;
  animation: pulse-border 2s infinite;
}

.timeline-normal {
  border-left: 5px solid #2196F3;
}


.alerta-linha-lateral {
  border-left: 5px solid #b42d08;
}


.timeline-critico {
  border-left: 5px solid #f44336;
}

@keyframes pulse-border {

  0%,
  100% {
    border-left-color: #f44336;
  }

  50% {
    border-left-color: #ff8a80;
  }
}

/* Animações */
.metric-icon-container {
  position: relative;
  display: inline-block;
}

.pulse-animation {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  opacity: 0.3;
  animation: pulse 2s infinite;
}

.pulse-animation.success {
  background-color: #4CAF50;
}

.pulse-animation.warning {
  background-color: #FF9800;
}

.pulse-animation.error {
  background-color: #F44336;
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 0.8;
  }

  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.3;
  }

  100% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 0.8;
  }
}

.heartbeat {
  animation: heartbeat 1.5s ease-in-out infinite;
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.1);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.1);
  }

  70% {
    transform: scale(1);
  }
}

/* Cards */
.metric-card,
.setor-card {
  transition: all 0.3s ease;
}

.metric-card:hover,
.setor-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.setor-card {
  cursor: pointer;
}

.border-success {
  border-left: 4px solid #4CAF50 !important;
}

.border-warning {
  border-left: 4px solid #FF9800 !important;
}

.border-info {
  border-left: 4px solid #2196F3 !important;
}

.border-grey {
  border-left: 4px solid #9E9E9E !important;
}

.border-error {
  border-left: 4px solid #F44336 !important;
}

/* Seção de Autorização */
.autorizacao-section {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 8px;
}

/* Tooltips */
.tooltip-content {
  font-size: 0.875rem;
  line-height: 1.4;
}

/* Status (direita) */
/* Ajustes do layout dos cards da timeline */
.timeline-main-status {
  min-width: 135px;
  text-align: right;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  align-items: flex-end;
}

.timeline-main-info {
  flex: 1;
  min-width: 60%;
  max-width: 70%;
}

/* Tamanhos dos ícones */
.timeline-card-main .v-icon {
  vertical-align: middle;
}

.metric-card {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.borda-primary {
  border-left: 4px solid #1976D2;
}

.borda-success {
  border-left: 4px solid #4CAF50;
}

.borda-warning {
  border-left: 4px solid #FFC107;
}

.borda-error {
  border-left: 4px solid #F44336;
}


.alerta-item {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.3s ease;
}

.alerta-item:hover {
  background-color: #fff8f8;
}


.timeline-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.borda-success {
  border-left: 4px solid #4CAF50;
}

.borda-warning {
  border-left: 4px solid #FFC107;
}

.dot-data {
  background-color: white;
  border: 2px solid #ccc;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 0.65rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.dot-dia {
  font-weight: bold;
  font-size: 0.85rem;
  color: #000;
}

.dot-mes {
  text-transform: uppercase;
  font-size: 0.65rem;
  color: #666;
}

.data-card {
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 60px;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.timeline-card {
  border-left: 4px solid #ccc;
  border-radius: 8px;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 1000px;
  margin-bottom: 12px;
}

.borda-success {
  border-left-color: #4CAF50;
}

.borda-warning {
  border-left-color: #FFC107;
}

.bg-blue-lighten-4 {
  background-color: #e3f2fd !important;
}

/* ================================
   Timeline - Visual Moderno
=============================== */

.timeline-container {
  padding: 0 16px 8px 16px;
  position: relative;
}

/* Garantir que a linha vertical apareça */
.timeline-with-line :deep(.v-timeline-divider__line) {
  display: block !important;
  width: 2px !important;
  background-color: #1976D2 !important;
  opacity: 1 !important;
}

.timeline-with-line :deep(.v-timeline-item__body) {
  padding-bottom: 24px !important;
}

/* Personalização dos pontos do timeline */
.timeline-with-line :deep(.v-timeline-divider__dot) {
  background-color: #d0dbe6 !important;
  border: 2px solid white !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.3) !important;
  color: #1976D2 !important;

}

.timeline-with-line :deep(.v-timeline-divider__dot) .v-icon {

  color: #1976D2 !important;
}


/* Estrutura do timeline */
.timeline-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

/* Cabeçalho fixo da timeline */
.timeline-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #1976D2;
  color: white;
  border-bottom: 1px solid #90caf9;
  padding: 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Conteúdo do timeline com scroll independente */
.timeline-content {
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
}

/* Container do card */
.timeline-card-container {
  margin-top: 0;
}

/* Ajustar o componente v-timeline para garantir que a linha apareça */
.timeline-with-line :deep(.v-timeline) {
  width: 100% !important;
}

.timeline-with-line :deep(.v-timeline-divider) {
  display: flex !important;
  min-height: 100% !important;
}

.timeline-with-line :deep(.v-timeline-item) {
  margin-bottom: 15px !important;
}

/* Cada item da timeline (um para cada movimentação) */
.timeline-item-custom {
  min-height: 90px;
}

/* Card de movimentação ("principal") */
.timeline-card-main {
  background: #f8fafc;
  border-radius: 10px;
  border-left: 5px solid #42a5f5;
  padding: 18px 20px;
  margin-bottom: 12px;
  box-shadow: 0 1px 10px 0 #0001;
  transition: box-shadow 0.3s, transform 0.3s;
  max-width: 100%;
  min-height: 120px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.timeline-card-main:hover {
  transform: translateY(-3px) scale(1.015);
  box-shadow: 0 4px 20px 0 #1976d230;
}



/* "Badge" da data (coluna esquerda) - Estilos base */
.date-badge {
  border-radius: 10px;
  min-width: 54px;
  min-height: 54px;
  padding: 7px 0 5px 0;
  margin-right: 16px;
  margin-left: 0;
  box-shadow: 0 1px 6px 0 #0002;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  z-index: 2;
  position: relative;
  color: #fff;
  transition: all 0.3s ease;
}

/* Cores dos badges conforme status */
.date-badge-success {
  background: #4CAF50;
}

.date-badge-warning {
  background: #FF9800;
}

.date-badge-error {
  background: #F44336;
}

/* Badge padrão (fallback) */
.date-badge:not(.date-badge-success):not(.date-badge-warning):not(.date-badge-error) {
  background: #1976d2;
}

.date-day {
  font-size: 22px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 3px;
  letter-spacing: -1px;
}

.date-month {
  font-size: 11px;
  text-transform: uppercase;
  color: #bbdefb;
  line-height: 1.1;
  letter-spacing: .8px;
}

/* Linha vertical da timeline - usa variáveis CSS customizadas do Vuetify */
.v-timeline {
  --v-timeline-line-width: 2.5px;
  --v-timeline-line-color: #1976d2;
}

.v-timeline-divider__line {
  background-color: var(--v-timeline-line-color) !important;
  width: var(--v-timeline-line-width) !important;
}



.v-timeline-item {
  align-items: flex-start !important;
}

.v-timeline-item--after .v-timeline-divider__line {
  min-height: 75px !important;
}

/* Chips dentro do card de movimentação */
.timeline-card-main .v-chip {
  margin-right: 6px;
  margin-bottom: 2px;
}

/* Status (direita) */
.timeline-main-status {
  min-width: 135px;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
}

/* Tamanhos dos ícones */
.timeline-card-main .v-icon {
  vertical-align: middle;
  margin-right: 4px;
  font-size: 18px;
}

/* Cards com tamanho uniforme */
.timeline-item-custom :deep(.v-timeline-item__body) {
  min-height: 120px;
  padding: 0;
  width: 100%;
}


/* RESPONSIVIDADE */
@media (max-width: 900px) {
  .timeline-card-main {
    padding: 15px 8px;
    font-size: .98em;
  }

  .date-badge {
    min-width: 38px;
    min-height: 38px;
    font-size: 13px;
  }

  .timeline-main-status {
    min-width: 105px;
    font-size: 12px;
  }
}

@media (max-width: 600px) {
  .timeline-container {
    padding-right: 3px;
    padding-left: 3px;
  }

  .timeline-card-main {
    padding: 8px 3px;
    font-size: .93em;
  }

  .date-badge {
    min-width: 30px;
    min-height: 30px;
    padding: 2px 0 2px 0;
    font-size: 11px;
  }
}


/* Wrapper para scroll e altura */
.alertas-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Cabeçalho fixo */
.alertas-header {
  position: sticky;
  top: 0;
  background-color: #ccd6e1;
  /* primary */
  color: black;
  z-index: 2;
  padding: 16px;

}

/* Conteúdo com scroll */
.alertas-content {
  overflow-y: auto;
  height: calc(100% - 64px);
  /* ajusta conforme a altura do título */
  padding: 16px;
}

/* Alerta individual: borda lateral colorida por prioridade */
.alerta-item {
  border-left-width: 4px !important;
}

.alerta-item[data-tipo="alta"] {
  border-left-color: #F44336 !important;
}

.alerta-item[data-tipo="media"] {
  border-left-color: #FF9800 !important;
}

.alerta-item[data-tipo="baixa"] {
  border-left-color: #1976D2 !important;
}

/* Chips de prioridade com fundo suave e texto contrastante */
.chip-alta {
  background-color: #FFCDD2 !important;
  color: #B71C1C !important;
}

.chip-media {
  background-color: #FFE0B2 !important;
  color: #E65100 !important;
}

.chip-baixa {
  background-color: #BBDEFB !important;
  color: #0D47A1 !important;
}

/* Ajustes gerais */
.alerta-item:hover {
  background-color: #fff8f8;
}

.heartbeat {
  animation: heartbeat 1.5s ease-in-out infinite;
}

@keyframes heartbeat {

  0%,
  28%,
  70% {
    transform: scale(1);
  }

  14%,
  42% {
    transform: scale(1.1);
  }
}

.tooltip-content {
  font-size: 0.875rem;
  line-height: 1.4;
}
</style>
